export default {
  daily_missions_mission_daily_react_posts_F_title: 'مفاعل المبتدئ 🔥',
  daily_missions_mission_daily_react_posts_C_title: 'مفاعل المحترف 🔥',
  daily_missions_mission_daily_react_posts_A_title: 'مفاعل الأسطورة 🔥',
  daily_missions_mission_daily_react_comments_F_title: 'صاحب التعليقات 💬',
  daily_missions_mission_daily_react_comments_C_title: 'قارئ التعليقات النشيط 💬',
  daily_missions_mission_daily_react_comments_A_title: 'سيد التعليقات 💬',
  daily_missions_mission_daily_react_replies_F_title: 'ردود متفاعلة ↩️',
  daily_missions_mission_daily_react_replies_C_title: 'الرادّ المتحمس ↩️',
  daily_missions_mission_daily_react_replies_A_title: 'أمير الردود ↩️',
  daily_missions_mission_total_react_posts_100_title: 'محب المنشورات ❤️',
  daily_missions_mission_total_react_comments_50_title: 'قارئ التعليقات 📖',
  daily_missions_mission_total_react_replies_50_title: 'محبّ الردود 💌',
  daily_missions_mission_daily_posts_F_title: 'صانع المحتوى 📝',
  daily_missions_mission_daily_posts_C_title: 'ناشر نشيط 🚀',
  daily_missions_mission_daily_posts_A_title: 'آلة المحتوى ⚡',
  daily_missions_mission_total_posts_10_title: 'عشرة منشورات ⚔️',
  daily_missions_mission_total_posts_50_title: 'مدوّن محترف 📜',
  daily_missions_mission_daily_comments_F_title: 'معلّق اليوم 💡',
  daily_missions_mission_daily_comments_C_title: 'المعلق المتمرس 💡',
  daily_missions_mission_daily_comments_A_title: 'صاحب الرأي 🗣️',
  daily_missions_mission_total_comments_25_title: 'ذو الرأي 🗣️',
  daily_missions_mission_daily_replies_F_title: 'الرادّ السريع ⚡',
  daily_missions_mission_daily_replies_C_title: 'المحاور النشيط ⚡',
  daily_missions_mission_daily_replies_A_title: 'محاور بارع 🎙️',
  daily_missions_mission_total_replies_25_title: 'محاور بارع 🎙️',
  daily_missions_mission_daily_tasbeeh_F_title: 'ذاكر اليوم 📿',
  daily_missions_mission_daily_tasbeeh_C_title: 'المسبّح المجتهد 🌙',
  daily_missions_mission_daily_tasbeeh_A_title: 'سيد الذكر ✨',
  daily_missions_mission_total_tasbeeh_1000_title: 'ألف تسبيحة 🏅',
  daily_missions_mission_adhkar_morning_title: 'أذكار الصباح 🌅',
  daily_missions_mission_adhkar_evening_title: 'أذكار المساء 🌆',
  daily_missions_mission_adhkar_both_title: 'يوم كامل بالذكر ✨',
  password_show: 'إظهار كلمة المرور',
  password_hide: 'إخفاء كلمة المرور',
  settings_header: 'الإعدادات',
  settings_section_account_security: 'الحساب والأمان',
  settings_email_address: 'عنوان البريد الإلكتروني',
  settings_change_email: 'تغيير البريد',
  settings_change_password: 'تغيير كلمة المرور',
  settings_new_password: 'كلمة المرور الجديدة',
  settings_confirm_password: 'تأكيد كلمة المرور الجديدة',
  settings_save_password: 'حفظ كلمة المرور',
  settings_saving: 'جاري الحفظ...',
  settings_account_success_title: 'تم التحديث',
  settings_account_error_title: 'تعذر التحديث',
  settings_email_updated: 'تم تغيير عنوان البريد الإلكتروني بنجاح.',
  settings_email_verification_sent: 'تم إرسال رابط تأكيد إلى البريد الجديد. لن يتغير بريد الحساب حتى تفتح الرابط وتؤكد العنوان.',
  settings_email_already_used: 'عنوان البريد الإلكتروني مستخدم بالفعل في حساب آخر.',
  settings_email_invalid: 'عنوان البريد الإلكتروني غير صالح.',
  settings_password_updated: 'تم تغيير كلمة المرور بنجاح.',
  settings_password_mismatch: 'كلمتا المرور غير متطابقتين.',
  settings_password_too_short: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.',
  settings_account_recent_login: 'لحماية حسابك، سجل الخروج ثم سجل الدخول مجدداً قبل تغيير البريد أو كلمة المرور.',
  settings_account_update_failed: 'تعذر تحديث بيانات الحساب.',
  settings_notifications_manage: 'إدارة الإشعارات وأنواعها',
  settings_section_theme: 'المظهر',
  settings_theme_light: 'الوضع الفاتح',
  settings_theme_dark: 'الوضع الداكن',
  settings_theme_system: 'حسب النظام',
  settings_toggle_theme_button: 'تبديل الوضع الآن',
  settings_section_language: 'اللغة',
  settings_language_description: 'اختر لغة واجهة التطبيق. يمكنك إضافة لغات أخرى لاحقاً.',
  settings_language_option_ar: 'العربية',
  settings_language_option_en: 'English',
  settings_section_direction: 'اتجاه العرض',
  settings_direction_description: 'اختر اتجاه عرض الواجهة سواء تلقائي بناءً على اللغة أو اجعلها LTR/RTL حسب تفضيلك.',
  settings_direction_auto: 'تلقائي (حسب اللغة)',
  settings_direction_rtl: 'من اليمين إلى اليسار (RTL)',
  settings_direction_ltr: 'من اليسار إلى اليمين (LTR)',
  settings_section_notifications: 'الإشعارات',
  settings_notifications_description: 'تفعيل الإشعارات للحصول على تنبيهات حية ومباشرة من التطبيق.',
  settings_notifications_note_windows: 'على ويندوز يمكن أن تصلك الإشعارات حتى إذا كان المتصفح غير ظاهر، لكن إذا أغلقت المتصفح أو عطّلت الإشعارات من إعدادات النظام فلن تصل.',
  settings_windows_step_1: 'اضغط مطولاً على أيقونة التطبيق في الشاشة الرئيسية',
  settings_windows_step_2: 'اختر "معلومات التطبيق" أو "App info"',
  settings_windows_step_3: 'اذهب إلى "الإشعارات" أو "Notifications"',
  settings_windows_step_4: 'فعّل الإشعارات',
  settings_check_notifications_button: 'تحقق من التفعيل',
  settings_notifications_enable_button: 'تفعيل الإشعارات',
  settings_notifications_blocked_title: '⚠️ الإشعارات محظورة من التطبيق',
  settings_notifications_blocked_details: 'لإعادة تفعيل الإشعارات، اتبع الخطوات التالية:',
  settings_notifications_disabled_note_blocked: '🚫 الإشعارات محظورة من التطبيق - لا يمكن ضبط التفضيلات حتى إعادة التفعيل من إعدادات التطبيق',
  settings_notifications_disabled_note_not_enabled: '⚠️ الإشعارات غير مفعّلة، لكن يمكنك ضبط تفضيلاتك مسبقاً',
  settings_notification_types_label: 'اختر أنواع الإشعارات التي تريد استقبالها:',
  settings_notification_type_mention_label: 'إشعارات الذكر',
  settings_notification_type_mention_desc: 'عندما يذكرك أحد في منشور أو تعليق',
  settings_notification_type_reactions_label: 'إشعارات التفاعل',
  settings_notification_type_reactions_desc: 'عندما يتفاعل أحد مع منشوراتك أو تعليقاتك',
  settings_notification_type_comments_label: 'إشعارات التعليقات',
  settings_notification_type_comments_desc: 'عندما يعلق أحد على منشوراتك',
  settings_notification_type_replies_label: 'إشعارات الردود',
  settings_notification_type_replies_desc: 'عندما يرد أحد على تعليقاتك',
  settings_notification_type_messages_label: 'إشعارات الرسائل',
  settings_notification_type_messages_desc: 'عند وصول رسائل خاصة أو جماعية',
  settings_notification_type_bans_label: 'إشعارات الحظر',
  settings_notification_type_bans_desc: 'عند حظر أو رفع حظر عن أحد محتوياتك',
  settings_notif_saving_indicator: 'جاري الحفظ...',
  settings_section_daily_plan: 'الخطة اليومية',
  settings_daily_plan_desc: 'إذا كنت تريد إعادة ضبط أسئلة الخطة اليومية، سيتم حذف إعدادات الخطة اليومية الحالية',
  settings_reset_daily_plan_button: 'إعادة تعيين أسئلة الخطة اليومية',
  settings_reset_daily_plan_resetting: 'جاري إعادة التعيين...',
  settings_section_legal_info: 'معلومات قانونية',
  settings_terms_of_service: 'شروط الاستخدام',
  settings_privacy_policy: 'سياسة الخصوصية',
  settings_child_safety: 'سياسة حماية الأطفال',
  settings_section_contact_us: 'تواصل معنا',
  settings_contact_description: 'لديك سؤال أو اقتراح؟ نحن هنا للمساعدة',
  settings_contact_email_label: 'support@amposter.com',
  settings_section_danger: 'منطقة الخطر',
  settings_delete_account_warning: 'حذف حسابك سيؤدي إلى حذف جميع بياناتك ومنشوراتك بشكل نهائي',
  settings_delete_account_button: 'حذف الحساب نهائياً',
  settings_delete_account_processing: 'جاري الحذف...',
  settings_confirm_delete_title: 'حذف الحساب نهائياً',
  settings_confirm_delete_message: 'هل أنت متأكد من حذف حسابك؟ سيتم حذف جميع بياناتك ومنشوراتك بشكل نهائي ولا يمكن استرجاعها.\n\n⚠️ تحذير مهم: لن تتمكن من إنشاء حساب جديد بنفس الإيميل لمدة 30 يوم.',
  settings_confirm_delete_confirm: 'حذف الحساب',
  settings_confirm_cancel: 'إلغاء',
  settings_confirm_reset_title: 'إعادة تعيين أسئلة الخطة اليومية',
  settings_confirm_reset_message: 'هل تريد حذف بيانات تفضيل الخطة اليومية الحالية؟ سيتم حذف user_prefs/{userId} فقط.',
  settings_confirm_reset_confirm: 'إعادة التعيين',
  settings_reset_success_title: 'تم بنجاح',
  settings_reset_success_message: 'تمت إعادة إعادة تهيئة أسئلة الخطة اليومية بنجاح.',
  settings_error_title: 'خطأ',
  settings_error_no_user_message: 'لم يتم العثور على معرف المستخدم. الرجاء تسجيل الدخول مرة أخرى.',
  settings_error_reset_fail_message: 'فشل إعادة تعيين أسئلة الخطة اليومية. الرجاء المحاولة مرة أخرى.',
  settings_error_delete_prefix: 'حدث خطأ أثناء حذف الحساب:',
  settings_unknown_error: 'خطأ غير معروف',
  settings_deletion_overlay_title: 'جاري حذف الحساب...',
  settings_deletion_warning: 'لا تغلق هذه الصفحة أو تضغط على زر الرجوع',
  settings_deletion_step_fetch_posts: 'جاري جلب بيانات منشوراتك...',
  settings_deletion_step_deleting_posts: 'جاري حذف {count} منشور...',
  settings_deletion_step_posts_deleted: '✅ تم حذف جميع منشوراتك',
  settings_deletion_step_no_posts: '✅ لا توجد منشورات لحذفها',
  settings_deletion_step_deleting_role: 'جاري حذف دور المستخدم...',
  settings_deletion_step_role_deleted: '✅ تم حذف دور المستخدم',
  settings_deletion_step_deleting_points: 'جاري حذف النقاط والعملات...',
  settings_deletion_step_points_deleted: '✅ تم حذف النقاط والعملات',
  settings_deletion_step_deleting_hashtags: 'جاري حذف الهاشتاقات...',
  settings_deletion_step_hashtags_deleted: '✅ تم حذف الهاشتاقات',
  settings_deletion_step_deleting_quran_progress: 'جاري حذف تقدم القرآن...',
  settings_deletion_step_quran_progress_deleted: '✅ تم حذف تقدم القرآن',
  settings_deletion_step_deleting_quran_status: 'جاري حذف حالة القرآن...',
  settings_deletion_step_quran_status_deleted: '✅ تم حذف حالة القرآن',
  settings_deletion_step_deleting_notifications: 'جاري حذف الإشعارات...',
  settings_deletion_step_notifications_deleted: '✅ تم حذف الإشعارات',
  settings_deletion_step_deleting_suggestions: 'جاري حذف تقارير الاقتراحات...',
  settings_deletion_step_suggestions_deleted: '✅ تم حذف تقارير الاقتراحات',
  settings_deletion_step_deleting_deleted_records: 'جاري حذف سجلات المنشورات المحذوفة...',
  settings_deletion_step_deleted_records_deleted: '✅ تم حذف سجلات المنشورات المحذوفة',
  settings_deletion_step_deleting_videos: 'جاري حذف الفيديوهات...',
  settings_deletion_step_videos_deleted: '✅ تم حذف الفيديوهات',
  settings_deletion_step_deleting_team_posts: 'جاري حذف منشورات الفريق...',
  settings_deletion_step_team_posts_deleted: '✅ تم حذف منشورات الفريق',
  settings_deletion_step_deleting_profile: 'جاري حذف بيانات الملف الشخصي...',
  settings_deletion_step_profile_deleted: '✅ تم حذف بيانات الملف الشخصي',
  settings_deletion_step_removing_appstatus: 'جاري إزالة حالة المستخدم من AppStatus...',
  settings_deletion_step_appstatus_removed: '✅ تمت إزالة حالة المستخدم من AppStatus',
  settings_deletion_step_deleting_auth: 'جاري حذف حساب المصادقة...',
  settings_deletion_step_auth_deleted: '✅ تم حذف حساب المصادقة نهائياً',
  settings_deletion_step_logged_out_after_delete: '✅ تم تسجيل الخروج',
  settings_deletion_step_cleanup_cache: 'جاري تنظيف البيانات المحلية والcache...',
  settings_deletion_step_cleanup_done: '✅ تم تنظيف البيانات المحلية والcache',
  settings_deletion_step_delete_success: '✨ تم حذف حسابك بنجاح!',
  settings_deletion_step_logout_warning: '⚠️ تم تسجيل الخروج (يتطلب حذف الحساب إعادة تسجيل دخول مؤخراً)',
  settings_deletion_step_logout_partial: '⚠️ تم تسجيل الخروج (لم يتم حذف حساب المصادقة)',
  profile_menu_loading: 'جاري التحميل...',
  profile_menu_feature_dev_message: '{feature} قيد التطوير',
  profile_menu_profile_image_alt: 'صورة الملف الشخصي',
  profile_menu_unknown: 'مجهول',
  profile_menu_unknown_tag: 'مجهول',
  profile_menu_inventory: 'حقيبتي',
  bottom_nav_unread_notifications: 'إشعارات غير مقروءة',
  profile_menu_view_profile: 'عرض الملف الشخصي',
  profile_menu_notifications: 'التنبيهات',
  profile_menu_team: 'الفريق',
  profile_menu_games: 'الألعاب',
  profile_menu_friend_requests: 'المعارف',
  profile_menu_messages: 'الرسائل',
  profile_menu_store: 'المتجر',
  profile_menu_wallet: 'المحفظة',
  profile_menu_plugins: 'الإضافات',
  profile_menu_plugins_description: 'اختر الاختصارات الإضافية التي تريد إظهارها في قائمة ملفك الشخصي.',
  profile_menu_create_event: 'إنشاء فعالية',
  profile_menu_quran: 'القرآن الكريم',
  profile_menu_characters: 'الشخصيات الإسلامية',
  profile_menu_tasbeeh: 'مسابقة الأذكار',
  profile_menu_prayer_tracker: 'متابعة الصلوات',
  profile_menu_adhkar: 'أذكار الصباح والمساء',
  profile_menu_create_plan: 'إنشاء خطة اليوم',
  profile_menu_saraha: 'صارحني',
  profile_menu_currency_log: 'سجل العملات',
  profile_menu_daily_quiz: 'مسابقة الأسئلة اليومية',
  profile_menu_reports_box: 'صندوق البلاغات',
  profile_menu_my_hashtags: 'الهاشتاغات الخاصة بي',
  profile_menu_saved_posts: 'المنشورات المحفوظة',
  profile_menu_drafts: 'المسودات',
  profile_menu_events: 'الفعاليات',
  profile_menu_settings: 'الإعدادات',
  profile_menu_staff: 'طاقم العمل',
  profile_menu_moderation_log: 'سجل الإجراءات الإدارية',
  profile_menu_create_daily_question: 'إنشاء سؤال يومي',
  profile_menu_deleted_posts: 'المنشورات المحذوفة',
  profile_menu_logs_section: 'السجلات',
  profile_menu_suggestions_box: 'الاقتراحات',
  profile_menu_unified_reports_system: 'البلاغات',
  profile_menu_admin_section: 'الإدارة',
  profile_menu_switch_account: 'تبديل الحساب',
  profile_menu_logout: 'تسجيل الخروج',
  profile_menu_switch_error_generic: 'تعذّر فتح واجهة تبديل الحسابات. الرجاء المحاولة مرة أخرى.',
  profile_menu_switch_session_expired: 'انتهت جلسة هذا الحساب. الرجاء تسجيل الدخول مجدداً.',
  profile_menu_logout_switch_message: 'عند تسجيل الخروج من هذا الحساب سيُزال من هذا الجهاز. هل ترغب في المتابعة؟',
  profile_menu_add_account: 'إضافة حساب',
  profile_menu_main_account: 'الحساب الرئيسي',
  islamic_hub_title: 'إسلاميات',
  islamic_hub_subtitle: 'مساحتك اليومية للتقرب من الله',
  islamic_hub_desc_adhkar: 'ابدأ يومك واختمه بذكر الله',
  islamic_hub_desc_tasbeeh: 'نافس نفسك واكسب شارات يومية',
  islamic_hub_desc_prayer_tracker: 'تابع صلواتك وحافظ على انتظامها',
  islamic_hub_desc_characters: 'تعرّف على سِيَر الصحابة والعلماء',
  islamic_hub_desc_quran: 'اقرأ واحفظ آيات الذكر الحكيم',
  prayer_tracker_title: 'متابعة الصلوات',
  prayer_tracker_tab_prayers: 'الصلوات',
  prayer_tracker_tab_missed: 'الفائتة',
  prayer_tracker_tab_adhkar: 'الأذكار',
  prayer_tracker_sunnah_streak: 'streak السنن',
  prayer_tracker_fard_progress: 'الفروض {done}/{total}',
  prayer_tracker_sunnah_progress: 'السنن {done}/{total}',
  bottom_nav_home: 'الرئيسية',
  bottom_nav_missions: 'الشارات',
  bottom_nav_create_post: 'إنشاء منشور',
  bottom_nav_create_newspaper: 'إنشاء جريدة',
  bottom_nav_drafts: 'المسودات',
  bottom_nav_create_poll: 'إنشاء تصويت',
  bottom_nav_create_quiz: 'إنشاء Quiz',
  bottom_nav_create_video: 'فيديو قصير (Reels)',
  bottom_nav_team: 'إسلاميات',
  bottom_nav_more: 'المزيد',
  settings_section_bottom_navbar_direction: 'اتجاه شريط التنقل السفلي',
  settings_bottom_navbar_direction_description: 'يمكنك ضبط اتجاه شريط التنقل السفلي بشكل مستقل عن اتجاه باقي التطبيق.',

  // LoginPage.js
  login_language_toggle_aria: 'تبديل اللغة',
  login_logo_alt: 'شعار التطبيق',
  login_welcome: 'مرحباً بعودتك!',
  login_email_divider: 'أو استخدم الإيميل',
  login_email_placeholder: 'you@domain.com',
  login_password_placeholder: 'كلمة المرور',
  login_confirm_password_placeholder: 'تأكيد كلمة المرور',
  login_terms_intro: 'من خلال المتابعة، فأنت توافق على',
  login_terms_link: 'شروط الاستخدام',
  login_privacy_link: 'سياسة الخصوصية',
  login_signin_button: 'تسجيل الدخول',
  login_signing_in: 'جاري تسجيل الدخول...',
  login_signup_button: 'إنشاء حساب',
  login_creating_account: 'جاري إنشاء الحساب...',
  login_forgot_password: 'نسيت كلمة المرور؟',
  login_sending_reset: 'جاري إرسال رابط الاستعادة...',
  login_install_button: 'تثبيت التطبيق',
  login_resend_verification: 'إعادة إرسال رسالة التحقق',
  login_no_account: 'لا تملك حسابًا؟',
  login_have_account: 'لديك حساب؟',
  login_signup_link: 'إنشاء حساب',
  login_signin_link: 'تسجيل الدخول',
  login_error_email_password_required: 'يرجى إدخال البريد الإلكتروني وكلمة المرور',
  login_error_password_mismatch: 'كلمة المرور غير متطابقة',
  login_error_password_min_length: 'كلمة المرور يجب أن تكون {min} أحرف على الأقل',
  login_error_password_max_length: 'كلمة المرور يجب ألا تتجاوز {max} حرفًا',
  login_error_password_blank: 'كلمة المرور لا يمكن أن تتكون من مسافات فقط',
  login_password_requirements: 'متطلبات كلمة المرور',
  login_password_requirement_met: 'الشرط مستوفى',
  login_password_requirement_unmet: 'الشرط غير مستوفى',
  login_password_requirement_length: 'من {min} إلى {max} حرفًا',
  login_password_requirements_note: 'لا يُشترط حرف كبير أو رقم أو رمز خاص.',
  login_password_confirmation_required: 'يجب أن يتطابق التأكيد مع كلمة المرور',
  login_password_confirmation_matched: 'كلمتا المرور متطابقتان',
  login_info_verification_sent: '📧 تم إرسال رابط التحقق إلى بريدك الإلكتروني. تحقق من مجلد السبام إذا لم تجده.',
  login_verification_dialog_title: 'تحقق من بريدك الإلكتروني',
  login_verification_dialog_confirm: 'حسنًا',
  login_verification_dialog_close: 'إغلاق النافذة',
  login_error_email_in_use: 'البريد الإلكتروني مستخدم بالفعل',
  login_error_invalid_email: 'البريد الإلكتروني غير صالح',
  login_error_signup_failed: 'فشل في إنشاء الحساب',
  login_error_verify_email: 'يرجى تأكيد بريدك الإلكتروني أولاً',
  login_error_user_not_found: 'البريد الإلكتروني غير مسجل',
  login_error_wrong_password: 'كلمة المرور غير صحيحة',
  login_error_reset_email_required: 'أدخل بريدك الإلكتروني لاستعادة كلمة المرور',
  login_info_password_reset_sent: 'تم استلام طلبك. إذا كان البريد مرتبطاً بحساب مؤهل للاستعادة، فستصلك رسالة برابط إعادة تعيين كلمة المرور. قد يستغرق وصولها بضع دقائق؛ تحقق من مجلد الرسائل غير المرغوب فيها أيضاً.',
  login_password_reset_dialog_title: 'تحقق من بريدك الإلكتروني',
  login_password_reset_email_label: 'البريد الذي أدخلته',
  login_password_reset_error_title: 'تعذّر إرسال رابط الاستعادة',
  login_password_reset_not_found_title: 'لم يتم العثور على الحساب',
  login_password_reset_not_found_message: 'لم يتم العثور على حساب بهذا البريد الإلكتروني. تأكد من كتابته بشكل صحيح ثم حاول مجدداً.',
  login_password_reset_edit_email: 'تصحيح البريد الإلكتروني',
  login_error_password_reset_unavailable: 'خدمة إرسال البريد غير متاحة حالياً. يرجى المحاولة لاحقاً.',
  login_password_reset_google_title: 'استخدم تسجيل الدخول عبر Google',
  login_password_reset_google_message: 'هذا البريد مرتبط بتسجيل الدخول عبر Google، لذلك لا توجد كلمة مرور لإعادة تعيينها. استخدم زر المتابعة باستخدام Google.',
  login_error_password_reset_failed: 'تعذر إرسال رسالة استعادة كلمة المرور. حاول مرة أخرى.',
  login_error_verification_resend_failed: 'تعذر إعادة إرسال رسالة التحقق. حاول تسجيل الدخول مرة أخرى.',
  login_error_user_disabled: 'تم تعطيل هذا الحساب. تواصل مع الدعم للمساعدة.',
  login_error_too_many_requests: 'محاولات كثيرة جداً. انتظر قليلاً ثم حاول مرة أخرى.',
  login_error_network: 'تعذر الاتصال. تحقق من اتصال الإنترنت وحاول مرة أخرى.',
  login_add_account_title: 'إضافة حساب',
  login_add_account_subtitle: 'سجّل الدخول لإضافة حساب آخر على هذا الجهاز',
  login_add_account_cancel: 'إلغاء',
  login_error_signin_failed: 'فشل في تسجيل الدخول',
  login_error_google_failed: 'فشل تسجيل الدخول عبر Google',
  login_info_verification_resent: '📧 تم إعادة إرسال رابط التحقق. تحقق من مجلد السبام إذا لم تجده.',

  // ProfileModal.jsx
  profile_modal_title: 'الملف الشخصي',

  // Profile.jsx
  profile_loading: 'جارِ تحميل بيانات المستخدم...',
  profile_user_not_found: 'المستخدم غير موجود',
  profile_user_not_found_desc: 'الرابط الذي تبحث عنه غير صحيح أو أن المستخدم قد تم حذفه.',
  profile_go_back: 'العودة للخلف',
  profile_logout_confirm_title: 'تأكيد تسجيل الخروج',
  profile_logout_confirm_message: 'هل تريد تسجيل الخروج من حسابك؟',
  profile_logout_confirm_btn: 'نعم، خروج',
  profile_logout_error_message: 'حدث خطأ أثناء تسجيل الخروج',
  profile_copy_link: 'نسخ رابط الملف الشخصي',
  profile_copied_title: 'تم النسخ',
  profile_copy_link_success: 'تم نسخ رابط البروفايل',
  profile_copy_user_id: 'نسخ معرف المستخدم (ID)',
  profile_copy_id_success: 'تم نسخ معرف المستخدم بنجاح',
  profile_view_user_info: 'عرض معلومات المستخدم',
  profile_view_activity: 'عرض إحصائيات النشاط',
  profile_user_notes: 'ملاحظات المستخدم',
  profile_add_note: 'إضافة ملاحظة',
  profile_edit_note: 'تعديل الملاحظة',
  profile_delete_note: 'حذف الملاحظة',
  profile_note_placeholder: 'اكتب ملاحظة داخلية عن هذا المستخدم...',
  profile_note_save: 'حفظ الملاحظة',
  profile_note_cancel: 'إلغاء',
  profile_no_notes: 'لا توجد ملاحظات لهذا المستخدم بعد',
  profile_notes_load_error: 'حدث خطأ أثناء تحميل الملاحظات',
  profile_note_added: 'تمت إضافة الملاحظة بنجاح',
  profile_note_updated: 'تم تحديث الملاحظة بنجاح',
  profile_note_deleted: 'تم حذف الملاحظة بنجاح',
  profile_note_save_error: 'حدث خطأ أثناء حفظ الملاحظة',
  profile_note_delete_error: 'حدث خطأ أثناء حذف الملاحظة',
  profile_note_empty_error: 'يرجى كتابة الملاحظة قبل الحفظ',
  profile_note_permission_error: 'ليس لديك صلاحية لعرض أو إدارة ملاحظات هذا المستخدم',
  profile_note_delete_confirm_title: 'حذف الملاحظة',
  profile_note_delete_confirm_message: 'هل أنت متأكد من حذف هذه الملاحظة؟ لا يمكن التراجع عن هذا الإجراء.',
  profile_note_author: 'الكاتب',
  profile_note_updated_at: 'آخر تحديث',
  profile_note_type_positive: 'إيجابية',
  profile_note_type_negative: 'سلبية',
  profile_note_type_neutral: 'محايدة',
  profile_can_participate_events: 'يمكنه المشاركة في الفعاليات',
  profile_can_participate_events_desc: 'يتحكم في السماح لهذا المستخدم بالمشاركة في الفعاليات',
  profile_cannot_participate_events: 'لا يمكنه المشاركة في الفعاليات',
  profile_allow_image: 'السماح بالصورة',
  profile_ban_image: 'حظر الصورة',
  profile_allow_cover: 'السماح بالغلاف',
  profile_ban_cover: 'حظر الغلاف',
  profile_send_warning: 'إرسال تحذير',
  create_profile_header: 'إنشاء الملف الشخصي',
  create_profile_uploading_image: 'جاري رفع الصورة...',
  create_profile_creating_profile: 'جاري إنشاء الملف الشخصي...',
  create_profile_wait_message: 'يرجى الانتظار وعدم إغلاق الصفحة',
  create_profile_timeout_warning: '⚠️ الاتصال بطيء — يمكنك المتابعة وتغيير بياناتك لاحقاً من إعدادات الملف الشخصي',
  create_profile_image_alt: 'صورة الملف الشخصي',
  create_profile_name_placeholder: 'الاسم',
  create_profile_finding_tag: 'جاري إيجاد معرف متاح...',
  create_profile_tag_placeholder: 'معرف المستخدم',
  create_profile_refresh_tag_title: 'توليد معرف عشوائي آخر',
  create_profile_tag_helper: 'يمكنك تغييره أو الإبقاء على المعرف المقترح — يجب أن يكون فريدًا (3 أحرف على الأقل)',
  create_profile_description_placeholder: 'اكتب وصفاً مختصراً عنك',
  create_profile_checking: 'جاري التحقق...',
  create_profile_saving: 'جاري الحفظ...',
  create_profile_create_button: 'إنشاء الملف الشخصي',
  create_profile_crop_title: 'قص الصورة',
  create_profile_crop_desc: 'حرك الصورة وقم بتكبيرها لتحديد المنطقة المرغوبة',
  create_profile_zoom_label: 'تكبير',
  create_profile_crop_cancel: 'إلغاء قص الصورة',
  create_profile_crop_apply: 'تأكيد قص الصورة',
  create_profile_signin_wait_title: 'جاري تسجيل الدخول',
  create_profile_signin_wait_message: 'يرجى الانتظار حتى يكتمل تسجيل الدخول إلى قاعدة البيانات ثم حاول مرة أخرى',
  profile_ban_publish: 'حظر النشر',
  profile_ban_comment: 'حظر التعليق',
  profile_ban_reaction: 'حظر التفاعل',
  profile_ban_message: 'حظر الرسائل',
  profile_ban_permanent: 'حظر عام',
  profile_moderation_actions: 'إجراءات الحظر',
  profile_unban_publish: 'إلغاء حظر النشر',
  profile_unban_comment: 'إلغاء حظر التعليق',
  profile_unban_reaction: 'إلغاء حظر التفاعل',
  profile_unban_message: 'إلغاء حظر الرسائل',
  profile_unban_permanent: 'إلغاء الحظر العام',
  profile_grant_title: 'منح لقب',
  profile_grant_badge: 'منح شارة',
  profile_add_to_staff: 'إضافة إلى الطاقم',
  profile_delete_title: 'حذف لقب',
  profile_delete_badge: 'حذف شارة',
  profile_choose_frame: 'اختيار اطار',
  profile_edit_profile: 'تعديل الملف الشخصي',
  profile_follow: 'متابعة',
  profile_unfollow: 'إلغاء المتابعة',
  profile_follows_you: 'يتابعك',
  profile_join_date: 'تاريخ الانضمام',
  profile_followers: 'المتابعون',
  profile_following: 'يُتابِع',
  profile_insufficient_balance: 'رصيدك غير كافٍ لإتمام العملية',
  profile_tab_latest: 'آخر المنشورات',
  profile_tab_lists: 'قائمة المنشورات',
  profile_loading_more: 'جاري تحميل المزيد...',
  profile_loading_posts: 'جاري تحميل المنشورات...',
  profile_no_posts: 'لا توجد منشورات حتى الآن',
  profile_list_untitled: 'قائمة بدون عنوان',
  profile_post_count_unit: 'منشور',
  profile_no_lists: 'لا توجد قوائم منشورات حتى الآن',
  profile_no_lists_hint: 'اضغط على الزر + لإنشاء قائمتك الأولى',
  profile_cancel: 'إلغاء',
  profile_save: 'حفظ',
  profile_delete: 'حذف',
  profile_close: 'إغلاق',
  profile_error_title: 'خطأ',
  profile_success_title: 'تم بنجاح',
  profile_updated_title: 'تم التحديث',
  profile_sent_title: 'تم الإرسال',
  profile_reported_title: 'تم الإبلاغ',
  profile_unknown: 'غير معروف',
  profile_this_user: 'هذا المستخدم',
  profile_send_btn: 'إرسال',
  profile_update_error: 'حدث خطأ في تحديث البيانات',
  profile_image_banned: 'تم حظر صورة المستخدم',
  profile_image_allowed: 'تم السماح بصورة المستخدم',
  profile_cover_banned: 'تم حظر غلاف المستخدم',
  profile_cover_allowed: 'تم السماح بغلاف المستخدم',
  profile_send_warning_title: 'إرسال تحذير',
  profile_send_warning_message: 'هل تريد إرسال تحذير إلى {name}؟',
  profile_warning_sent_success: 'تم إرسال التحذير بنجاح',
  profile_warning_sent_error: 'حدث خطأ أثناء إرسال التحذير',
  profile_already_reported_image: 'لقد قمت بالإبلاغ عن هذه الصورة مسبقاً',
  profile_already_reported_cover: 'لقد قمت بالإبلاغ عن هذا الغلاف مسبقاً',
  profile_report_success: 'تم إرسال الإبلاغ بنجاح',
  profile_report_error: 'حدث خطأ في إرسال الإبلاغ',
  profile_title_name_required: 'يجب إدخال اسم اللقب',
  profile_title_granted_success: 'تم منح اللقب بنجاح',
  profile_title_granted_error: 'حدث خطأ في منح اللقب',
  profile_title_deleted_success: 'تم حذف اللقب بنجاح',
  profile_title_deleted_error: 'حدث خطأ في حذف اللقب',
  profile_title_select_required: 'يرجى اختيار لقب لحذفه',
  profile_badge_select_required: 'يرجى اختيار شارة',
  profile_badge_name_required: 'يجب إدخال اسم الشارة',
  profile_badge_granted_success: 'تم منح شهادة الإمتياز بنجاح',
  profile_badge_granted_error: 'حدث خطأ في منح الشارة',
  profile_badge_deleted_success: 'تم حذف الشارة بنجاح',
  profile_badge_deleted_error: 'حدث خطأ في حذف الشارة',
  profile_staff_added_success: 'تم إضافة المستخدم إلى الطاقم برتبة غير مخصص',
  profile_staff_added_error: 'حدث خطأ في إضافة المستخدم إلى الطاقم',
  profile_ban_save_error: 'حدث خطأ أثناء حفظ الحظر',
  profile_ban_success: 'تم تطبيق {banLabel} بنجاح',
  profile_unban_success: 'تم إلغاء {banLabel} بنجاح',
  profile_ban_generic: 'الحظر',
  profile_grant_title_dialog_heading: 'منح لقب',
  profile_title_name_label: 'إسم اللقب',
  profile_title_name_placeholder: 'أدخل اسم اللقب',
  profile_duration_label: 'مدة اللقب',
  profile_duration_1day: 'يوم واحد',
  profile_duration_3days: '3 أيام',
  profile_duration_month: 'شهر',
  profile_duration_permanent: 'دائم',
  profile_bg_color_label: 'لون الخلفية',
  profile_text_color_label: 'لون النص',
  profile_preview_label: 'معاينة',
  profile_preview_placeholder: 'معاينة اللقب',
  profile_delete_title_dialog_heading: 'حذف لقب',
  profile_select_title_to_delete: 'اختر اللقب للحذف',
  profile_select_title_placeholder: '-- اختر لقب --',
  profile_grant_badge_dialog_heading: 'منح شارة',
  profile_badge_name_label: 'اسم الشارة',
  profile_badge_name_placeholder: 'أدخل اسم الشارة',
  profile_select_badge_label: 'اختر شهادة',
  profile_delete_badge_dialog_heading: 'حذف شارة',
  profile_select_badge_to_delete: 'اختر الشارة للحذف',
  profile_select_badge_placeholder: '-- اختر شهادة --',
  profile_ban_target_label: 'المستخدم المستهدف',
  profile_ban_type_label: 'نوع الحظر',
  profile_ban_duration_label: 'مدة الحظر',
  profile_ban_temporary: 'مؤقت',
  profile_ban_amount_label: 'العدد',
  profile_ban_unit_label: 'الوحدة',
  profile_ban_unit_days: 'أيام',
  profile_ban_unit_months: 'شهور',
  profile_ban_reason_label: 'السبب',
  profile_ban_reason_placeholder: 'اكتب سبب الحظر',
  profile_unban_confirm_text: 'سيتم إلغاء {banLabel} عن هذا المستخدم.',
  profile_ban_current_reason: 'السبب الحالي',
  profile_unban_confirm_btn: 'إلغاء الحظر',
  profile_unban_dialog_heading: 'إلغاء {banLabel}',
  profile_user_info_heading: 'معلومات المستخدم',
  profile_info_name: 'الاسم',
  profile_info_username: 'اسم المستخدم',
  profile_info_email: 'الإيميل',
  profile_info_currency: 'عدد العملات',
  profile_info_currency_unit: 'عملة',
  profile_info_points: 'النقاط',
  profile_info_points_unit: 'نقطة',
  profile_info_violations: 'عدد المخالفات',
  profile_info_violations_unit: 'مخالفة',
  profile_info_saraha_sent: 'صارحني المرسلة',
  profile_info_messages_unit: 'رسائل',
  profile_info_team: 'الفريق',
  profile_info_no_team: 'لا ينتمي لفريق',
  profile_info_morning_streak: 'Streak أذكار الصباح',
  profile_info_evening_streak: 'Streak أذكار المساء',
  profile_info_tasbeeh_streak: 'Streak التسابيح',
  profile_info_days_unit: 'يوم',
  profile_info_join_date: 'تاريخ الانضمام',
  profile_info_unavailable: 'غير متوفر',
  profile_back_tooltip: 'رجوع',
  profile_logout_tooltip: 'تسجيل الخروج',
  profile_options_tooltip: 'خيارات',
  profile_drag_list_tooltip: 'تحريك القائمة',
  profile_coins_sent_to_ar: 'أرسلت عملات إلى: {name}',
  profile_coins_sent_to_ltr: '{name} :أرسلت عملات إلى',
  profile_coins_received_from_ar: 'حصلت على عملات من: {name}',
  profile_coins_received_from_ltr: '{name} :حصلت على عملات من',

  // HomePosts.jsx
  home_tab_following: 'المتابعين',
  home_tab_events: 'الفعاليات',
  home_tab_latest: 'أخر المنشورات',
  home_loading_posts: 'جاري تحميل المنشورات...',
  home_loading_more: 'جاري تحميل المزيد...',
  home_no_events: 'لا توجد فعاليات',
  home_no_following_posts: 'لا توجد منشورات من المتابَعين',
  home_end_of_feed: 'وصلت لنهاية المنشورات',
  home_status_fab_tooltip: 'ماذا يحدث الآن؟',
  home_search: 'بحث',
  home_filter_all: 'الكل',
  home_filter_newspapers: 'صحف',
  home_filter_videos: 'فيديوهات',
  home_filter_blogs: 'منشورات',
  home_filter_winners: 'الفائزون',
  home_filter_articles: 'منشورات',
  home_filter_polls: 'استطلاعات',
  home_filter_quizzes: 'اختبارات',
  home_filter_highlights: 'أبرز الفائزين',
  home_no_filtered_posts: 'لا توجد منشورات من هذا النوع حالياً',

  // PostCard.jsx
  postcard_ad_cancelled: 'تم إلغاء الإعلان',
  postcard_already_reported_message: 'لقد قمت بالإبلاغ عن هذا المنشور من قبل',
  postcard_already_reported_title: 'تم الإبلاغ مسبقاً',
  postcard_banned_reaction_message: 'لديك حظر على التفاعل ولا يمكنك إرسال ردود فعل.',
  postcard_banned_title: 'محظور',
  postcard_block: 'حظر',
  postcard_block_post_message: 'هل أنت متأكد من أنك تريد حظر هذا المنشور لمخالفته قوانين التطبيق؟',
  postcard_block_post_title: 'حظر المنشور',
  postcard_blocked_message: 'المنشور محظور - مخالفة لقوانين التطبيق 🚫',
  postcard_cancel: 'إلغاء',
  postcard_cancel_ad: 'إلغاء الإعلان',
  postcard_cancel_ad_message: 'هل تريد إلغاء جعل هذا المنشور إعلاناً؟',
  postcard_cancel_ad_title: 'إلغاء الإعلان',
  postcard_cannot_edit_message: 'لا يمكن تعديل منشور محظور من قبل الإدارة',
  postcard_cannot_edit_title: 'لا يمكن تعديل المنشور',
  postcard_close: 'إغلاق',
  postcard_coin_alt: 'coin',
  postcard_comments: 'تعليقات',
  postcard_convert_to_ad: 'تحويل لإعلان',
  postcard_convert_to_ad_message: 'هل تريد جعل هذا المنشور إعلاناً مميزاً؟',
  postcard_convert_to_ad_title: 'تحويل لإعلان',
  postcard_converted_to_ad: 'تم تحويل المنشور لإعلان',
  postcard_copied_title: 'تم النسخ',
  postcard_copy_link_failed: 'فشل نسخ الرابط',
  postcard_cover_alt: 'Cover',
  postcard_delete: 'حذف',
  postcard_delete_post_message: 'هل أنت متأكد من أنك تريد حذف هذا المنشور؟',
  postcard_delete_post_title: 'حذف المنشور',
  postcard_done: 'تم',
  postcard_error_title: 'خطأ',
  postcard_frame_alt: 'Frame',
  postcard_hide: 'حجب',
  postcard_hide_post_message: 'هل أنت متأكد من أنك تريد حجب هذا المنشور؟',
  postcard_hide_post_title: 'حجب المنشور',
  postcard_ok: 'حسناً',
  postcard_pin: 'تثبيت',
  postcard_pin_message: 'هل تريد تثبيت هذا المنشور؟',
  postcard_pin_title: 'تثبيت المنشور',
  postcard_post_blocked: 'تم حظر المنشور',
  postcard_post_link_copied: 'تم نسخ رابط المنشور بنجاح',
  postcard_post_pinned: 'تم تثبيت المنشور',
  postcard_post_removed_from_saved: 'تم إزالة المنشور من المحفوظات',
  postcard_post_saved: 'تم حفظ المنشور',
  postcard_post_title: 'المنشور',
  postcard_post_unblocked: 'تم إلغاء حظر المنشور',
  postcard_post_unpinned: 'تم إلغاء تثبيت المنشور',
  postcard_profile_image_alt: 'صورة البروفايل',
  postcard_reaction_angry: 'أغضبني',
  postcard_reaction_care: 'إستمر',
  postcard_reaction_haha: 'أضحكني',
  postcard_reaction_like: 'أفدتني',
  postcard_reaction_love: 'أبدعت',
  postcard_reaction_sad: 'أحزنني',
  postcard_reaction_wow: 'أدهشني',
  postcard_reactions_closed_message: 'صاحب المنشور قد أغلق التفاعلات على هذا المنشور',
  postcard_reactions_closed_title: 'التفاعلات مغلقة',
  postcard_read_more: 'اقرأ المزيد',
  postcard_remove: 'إزالة',
  postcard_remove_from_events_message: 'هل تريد إزالة هذا المنشور من الفعاليات؟',
  postcard_remove_from_events_title: 'إزالة من الفعاليات',
  postcard_remove_from_list_message: 'هل أنت متأكد من رغبتك في إزالة هذا المنشور من القائمة؟',
  postcard_remove_from_list_title: 'إزالة من القائمة',
  postcard_removed_from_events_success: 'تم إزالة المنشور من الفعاليات',
  postcard_removed_from_list_message: 'تمت إزالة المنشور من القائمة بنجاح! سيتم تحديث الصفحة.',
  postcard_removed_title: 'تمت الإزالة',
  postcard_report: 'إبلاغ',
  postcard_report_post_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا المنشور؟',
  postcard_report_post_title: 'إبلاغ عن المنشور',
  postcard_reported_message: 'تم الإبلاغ عن المنشور بنجاح',
  postcard_reported_title: 'تم الإبلاغ',
  postcard_set: 'تعيين',
  postcard_set_as_event_message: 'هل تريد تعيين هذا المنشور كفعالية؟',
  postcard_set_as_event_success: 'تم تعيين المنشور كفعالية',
  postcard_set_as_event_title: 'تعيين كمنشور فعالية',
  postcard_share_text: 'شاهد هذا المنشور',
  postcard_show_more: 'عرض المزيد',
  postcard_surah_label: 'سورة',
  postcard_unblock: 'إلغاء الحظر',
  postcard_unblock_post_message: 'هل أنت متأكد من أنك تريد إلغاء حظر هذا المنشور؟',
  postcard_unblock_post_title: 'إلغاء حظر المنشور',
  postcard_unhide: 'إلغاء الحجب',
  postcard_unhide_post_message: 'هل أنت متأكد من أنك تريد إلغاء حجب هذا المنشور؟',
  postcard_unknown_user: 'مستخدم غير معروف',
  postcard_unpin: 'إلغاء التثبيت',
  postcard_unpin_message: 'هل تريد إلغاء تثبيت هذا المنشور؟',
  postcard_unpin_title: 'إلغاء التثبيت',
  postcard_verified_alt: 'verified',
  postcard_video_link_copied: 'تم نسخ رابط الفيديو بنجاح',
  postcard_viewing_as_moderator: 'أنت ترى هذا المحتوى لأنك مسؤول',
  postcard_yes: 'نعم',

  // UnifiedPostMenu.jsx
  unified_post_menu_done: 'تم',
  unified_post_menu_error: 'خطأ',
  unified_post_menu_warning: 'تنبيه',
  unified_post_menu_cancel: 'إلغاء',
  unified_post_menu_not_available: 'غير متاح',
  unified_post_menu_copied_title: 'تم النسخ',
  unified_post_menu_reported_title: 'تم الإبلاغ',

  // Edit
  unified_post_menu_edit_post: 'تعديل المنشور',

  // Save
  unified_post_menu_save_post: 'حفظ المنشور',
  unified_post_menu_remove_from_saved: 'إزالة من المحفوظات',
  unified_post_menu_post_saved: 'تم حفظ المنشور',
  unified_post_menu_post_removed_from_saved: 'تمت إزالة المنشور من المحفوظات',
  unified_post_menu_save_error: 'حدث خطأ أثناء حفظ المنشور',

  // Copy link
  unified_post_menu_copy_link: 'نسخ الرابط',
  unified_post_menu_link_copied: 'تم نسخ الرابط',
  unified_post_menu_copy_link_failed: 'فشل نسخ الرابط',

  // Add / remove from list
  unified_post_menu_add_to_list: 'إضافة إلى قائمة',
  unified_post_menu_remove_from_list: 'إزالة من القائمة',
  unified_post_menu_add_to_list_unavailable: 'إضافة المنشور إلى قائمة غير متاحة حالياً',
  unified_post_menu_remove_from_list_unavailable: 'إزالة المنشور من القائمة غير متاحة حالياً',

  // Comments
  unified_post_menu_open_comments: 'فتح التعليقات',
  unified_post_menu_close_comments: 'إغلاق التعليقات',
  unified_post_menu_enable_comments: 'السماح بالتعليقات',
  unified_post_menu_disable_comments: 'منع التعليقات',
  unified_post_menu_toggle_comments_message: 'هل تريد {action} على هذا المنشور؟',
  unified_post_menu_comments_opened: 'تم السماح بالتعليقات',
  unified_post_menu_comments_closed: 'تم إغلاق التعليقات',
  unified_post_menu_toggle_comments_error: 'حدث خطأ أثناء تحديث التعليقات',

  // Reactions
  unified_post_menu_open_reactions: 'فتح التفاعلات',
  unified_post_menu_close_reactions: 'إغلاق التفاعلات',
  unified_post_menu_enable_reactions: 'السماح بالتفاعلات',
  unified_post_menu_disable_reactions: 'منع التفاعلات',
  unified_post_menu_toggle_reactions_message: 'هل تريد {action} على هذا المنشور؟',
  unified_post_menu_reactions_opened: 'تم السماح بالتفاعلات',
  unified_post_menu_reactions_closed: 'تم إغلاق التفاعلات',
  unified_post_menu_toggle_reactions_error: 'حدث خطأ أثناء تحديث التفاعلات',

  // Pin
  unified_post_menu_pin_post: 'تثبيت المنشور',
  unified_post_menu_unpin: 'إلغاء التثبيت',
  unified_post_menu_pin_message: 'هل تريد تثبيت هذا المنشور في بروفايلك؟',
  unified_post_menu_unpin_message: 'هل تريد إزالة التثبيت؟',
  unified_post_menu_post_pinned: 'تم تثبيت المنشور',
  unified_post_menu_post_unpinned: 'تم إلغاء تثبيت المنشور',
  unified_post_menu_toggle_pin_error: 'حدث خطأ أثناء تحديث التثبيت',

  // Event (main post)
  unified_post_menu_set_as_event: 'تعيين كفعالية',
  unified_post_menu_remove_from_events: 'إزالة من الفعاليات',
  unified_post_menu_set_as_event_message: 'هل تريد تعيين هذا المنشور كفعالية؟',
  unified_post_menu_remove_from_events_message: 'هل تريد إزالة هذا المنشور من الفعاليات؟',
  unified_post_menu_post_set_as_event: 'تم تعيين المنشور كفعالية',
  unified_post_menu_post_removed_from_events: 'تم إزالة المنشور من الفعاليات',
  unified_post_menu_toggle_event_error: 'حدث خطأ أثناء تحديث الفعالية',

  // Advertisement
  unified_post_menu_convert_to_ad: 'تحويل لإعلان مميز',
  unified_post_menu_cancel_ad: 'إلغاء الإعلان',
  unified_post_menu_convert_to_ad_message: 'هل تريد تحويل هذا المنشور لإعلان مميز؟',
  unified_post_menu_cancel_ad_message: 'هل تريد إلغاء الإعلان؟',
  unified_post_menu_post_converted_to_ad: 'تم تحويل المنشور لإعلان',
  unified_post_menu_ad_cancelled: 'تم إلغاء الإعلان',
  unified_post_menu_toggle_ad_error: 'حدث خطأ أثناء تحديث الإعلان',

  // Delete
  unified_post_menu_delete_post: 'حذف المنشور',
  unified_post_menu_delete_post_message: 'سيتم نقل المنشور للمحذوفات، هل أنت متأكد؟',
  unified_post_menu_delete_post_error: 'حدث خطأ أثناء حذف المنشور',

  // Block
  unified_post_menu_block_post: 'حظر المنشور',
  unified_post_menu_unblock_post: 'إلغاء حظر المنشور',
  unified_post_menu_block_post_message: 'هل تريد حظر هذا المنشور لمخالفته القوانين؟',
  unified_post_menu_unblock_post_message: 'هل تريد إلغاء حظر هذا المنشور؟',
  unified_post_menu_post_blocked: 'تم حظر المنشور',
  unified_post_menu_post_unblocked: 'تم إلغاء حظر المنشور',
  unified_post_menu_block_notification: 'تم حظر منشورك لمخالفته القوانين',
  unified_post_menu_unblock_notification: 'تم رفع الحظر عن منشورك',
  unified_post_menu_toggle_block_error: 'حدث خطأ أثناء تحديث الحظر',

  // Hide from feed
  unified_post_menu_hide_from_feed: 'إخفاء من أخر المنشورات',
  unified_post_menu_show_in_feed: 'إظهار في أخر المنشورات',
  unified_post_menu_hide_from_feed_message: 'هل تريد إخفاء هذا المنشور من أخر المنشورات؟ سيبقى ظاهراً في صفحة البروفايل.',
  unified_post_menu_show_in_feed_message: 'هل تريد إعادة ظهور هذا المنشور في أخر المنشورات للجميع؟',
  unified_post_menu_post_hidden_from_feed: 'تم إخفاء المنشور من أخر المنشورات',
  unified_post_menu_post_shown_in_feed: 'تم إظهار المنشور في أخر المنشورات',
  unified_post_menu_toggle_hide_from_feed_error: 'حدث خطأ أثناء تحديث المنشور',

  // Report
  unified_post_menu_report_content: 'إبلاغ عن محتوى',
  unified_post_menu_report_dialog_heading: 'إبلاغ عن محتوى',
  unified_post_menu_report_dialog_subtitle: 'اكتب التفاصيل التي تريد إيصالها',
  unified_post_menu_report_details_label: 'تفاصيل البلاغ',
  unified_post_menu_report_details_placeholder: 'مثال: هذا المنشور مسيء، أو هذا الرد يحتوي على تهديد...',
  unified_post_menu_report_details_required: 'اكتب تفاصيل البلاغ أولاً',
  unified_post_menu_report_sent_message: 'تم إرسال البلاغ بنجاح وسيتم مراجعته',
  unified_post_menu_send_report: 'إرسال البلاغ',
  unified_post_menu_report_error: 'حدث خطأ أثناء إرسال البلاغ',

  // PostCommentsModal.jsx (pcm_*)
  pcm_reaction_like: 'أفدتني',
  pcm_reaction_love: 'أبدعت',
  pcm_reaction_care: 'إستمر',
  pcm_reaction_haha: 'أضحكني',
  pcm_reaction_wow: 'أدهشني',
  pcm_reaction_sad: 'أحزنني',
  pcm_reaction_angry: 'أغضبني',
  pcm_reactions_closed_title: 'التفاعلات مغلقة',
  pcm_reactions_closed_message: 'صاحب المنشور قد أغلق التفاعلات على هذا المنشور',
  pcm_login_required_title: 'مطلوب تسجيل الدخول',
  pcm_login_required_to_react: 'يرجى تسجيل الدخول للتفاعل',
  pcm_comment_deleted: 'التعليق محذوف',
  pcm_surah_label: 'سورة',
  pcm_banned_title: 'محظور',
  pcm_banned_comment_message: 'لديك حظر على التعليق ولا يمكنك كتابة تعليق.',
  pcm_login_required_before_comment: 'يرجى تسجيل الدخول قبل إضافة تعليق',
  pcm_insufficient_coins_title: 'عملات غير كافية',
  pcm_insufficient_coins_message: 'ليس لديك رصيد كافٍ لإرسال هذه المبالغ مع التعليق',
  pcm_post_deleted: 'المنشور محذوف',
  pcm_error_title: 'خطأ',
  pcm_error_post_owner_missing: 'حدث خطأ: صاحب المنشور غير موجود',
  pcm_coins_transfer_error: 'حدث خطأ أثناء تحويل العملات. لم يتم خصم أي مبلغ.',
  pcm_block_police: 'التعليق محظور - مخالفة أمنية 👮',
  pcm_block_health: 'التعليق محظور - مخالفة صحية 🏥',
  pcm_block_literature: 'التعليق محظور - مخالفة آداب 📚',
  pcm_block_law: 'التعليق محظور - مخالفة قانونية ⚖️',
  pcm_block_admin: 'التعليق محظور - قرار إداري 🔒',
  pcm_blocked_generic: 'التعليق محظور',
  pcm_login_required_action: 'يرجى تسجيل الدخول لإجراء هذا الإجراء',
  pcm_already_reported_title: 'تم الإبلاغ مسبقاً',
  pcm_already_reported_message: 'لقد قمت بالإبلاغ عن هذا التعليق من قبل',
  pcm_report_police_title: 'إبلاغ مركز الشرطة',
  pcm_report_police_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا التعليق لمركز الشرطة؟',
  pcm_login_required_to_report: 'يرجى تسجيل الدخول لإتمام الإبلاغ',
  pcm_report_police_theft_reason: 'إبلاغ مركز الشرطة عن سرقة',
  pcm_reported_title: 'تم الإبلاغ',
  pcm_report_police_success: 'تم الإبلاغ عن التعليق إلى مركز الشرطة بنجاح',
  pcm_report_error: 'حدث خطأ أثناء الإبلاغ',
  pcm_report_health_title: 'إبلاغ مركز الصحة',
  pcm_report_health_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا التعليق لمركز الصحة؟',
  pcm_report_health_depression_reason: 'إبلاغ مركز الصحة عن حالة إكتئاب',
  pcm_report_health_success: 'تم الإبلاغ عن التعليق إلى مركز الصحة بنجاح',
  pcm_report_literature_title: 'إبلاغ مركز الآداب',
  pcm_report_literature_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا التعليق لمركز الآداب؟',
  pcm_report_literature_abuse_reason: 'إبلاغ مركز الآداب عن إساءة',
  pcm_report_literature_success: 'تم الإبلاغ عن التعليق إلى مركز الآداب بنجاح',
  pcm_report_law_title: 'إبلاغ مركز القانون',
  pcm_report_law_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا التعليق لمركز القانون؟',
  pcm_report_law_violation_reason: 'إبلاغ مركز القانون عن إنتهاك القانون',
  pcm_report_law_success: 'تم الإبلاغ عن التعليق إلى مركز القانون بنجاح',
  pcm_login_required_for_report: 'يجب تسجيل الدخول للإبلاغ',
  pcm_report_submit_success: 'تم إرسال البلاغ بنجاح. شكراً لمساهمتك في الحفاظ على المجتمع.',
  pcm_report_submit_error: 'حدث خطأ أثناء إرسال البلاغ. حاول لاحقاً.',
  pcm_delete_comment_title: 'حذف التعليق',
  pcm_delete_comment_message: 'هل أنت متأكد من أنك تريد حذف هذا التعليق؟ لا يمكن التراجع عن هذا الإجراء.',
  pcm_delete_btn: 'حذف',
  pcm_cancel_btn: 'إلغاء',
  pcm_deleted_title: 'تم الحذف',
  pcm_delete_success: 'تم حذف التعليق بنجاح',
  pcm_delete_error: 'حدث خطأ أثناء حذف التعليق',
  pcm_permissions_title: 'صلاحيات',
  pcm_no_pin_permission: 'لا تملك صلاحية تثبيت التعليقات',
  pcm_unpinned_title: 'تم الإلغاء',
  pcm_unpinned_message: 'تم إلغاء تثبيت التعليق',
  pcm_pinned_title: 'تم التثبيت',
  pcm_pinned_message: 'تم تثبيت التعليق بنجاح',
  pcm_pin_error: 'حدث خطأ أثناء تثبيت التعليق',
  pcm_no_hide_permission: 'لا تملك صلاحية إخفاء التعليقات',
  pcm_hide_error: 'حدث خطأ أثناء تغيير حالة التعليق',
  pcm_modal_title: 'تعليقات المنشور',
  pcm_pin_comment: '📌 تثبيت التعليق',
  pcm_unpin_comment: '📌 إلغاء تثبيت التعليق',
  pcm_show_comment: '👁️‍🗨️ إظهار التعليق',
  pcm_hide_comment: '👻 إخفاء التعليق',
  pcm_block_notification: 'تم حظر تعليقك لمخالفته قوانين التطبيق',
  pcm_unblock_comment: 'إلغاء حظر التعليق',
  pcm_block_comment: 'حظر التعليق',
  pcm_report_comment: 'إبلاغ التعليق',
  pcm_hidden_comment_title: 'هذا التعليق مخفي',
  pcm_edit_comment: 'تعديل التعليق',
  pcm_add_comment: 'اضافة تعليق',
  pcm_cannot_send_coins_to_self: 'لا يمكنك إرسال عملات إلى منشورك',
  pcm_insufficient_coins_balance: 'ليس لديك عملات كافية',
  pcm_insufficient_currency_balance: 'لا تملك رصيدًا كافيًا من هذه العملة.',
  pcm_report_dialog_heading: 'إبلاغ عن التعليق',
  pcm_report_dialog_subtitle: 'اكتب تفاصيل البلاغ ليتمكن المشرفون من المراجعة بشكل أفضل',
  pcm_report_details_label: 'تفاصيل البلاغ',
  pcm_report_details_placeholder: 'مثال: هذا التعليق مسيء أو يحوي محتوى غير مناسب...',
  pcm_send_report_btn: 'إرسال البلاغ',
  pcm_yes_btn: 'نعم',

  // CommentReplyModal.jsx (crm_*)
  crm_reaction_like: 'أفدتني',
  crm_reaction_love: 'أبدعت',
  crm_reaction_care: 'إستمر',
  crm_reaction_haha: 'أضحكني',
  crm_reaction_wow: 'أدهشني',
  crm_reaction_sad: 'أحزنني',
  crm_reaction_angry: 'أغضبني',
  crm_block_police: 'الرد محظور - مخالفة أمنية 👮',
  crm_block_health: 'الرد محظور - مخالفة صحية 🏥',
  crm_block_literature: 'الرد محظور - مخالفة آداب 📚',
  crm_block_law: 'الرد محظور - مخالفة قانونية ⚖️',
  crm_block_admin: 'الرد محظور - قرار إداري 🔒',
  crm_blocked_generic: 'الرد محظور',
  crm_already_reported_title: 'تم الإبلاغ مسبقاً',
  crm_already_reported_message: 'لقد قمت بالإبلاغ عن هذا الرد من قبل',
  crm_report_police_title: 'إبلاغ مركز الشرطة',
  crm_report_police_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا الرد لمركز الشرطة؟',
  crm_report_police_theft_reason: 'إبلاغ مركز الشرطة عن سرقة',
  crm_reported_title: 'تم الإبلاغ',
  crm_report_police_success: 'تم الإبلاغ عن الرد إلى مركز الشرطة بنجاح',
  crm_error_title: 'خطأ',
  crm_report_error: 'حدث خطأ أثناء الإبلاغ',
  crm_report_health_title: 'إبلاغ مركز الصحة',
  crm_report_health_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا الرد لمركز الصحة؟',
  crm_report_health_depression_reason: 'إبلاغ مركز الصحة عن حالة إكتئاب',
  crm_report_health_success: 'تم الإبلاغ عن الرد إلى مركز الصحة بنجاح',
  crm_report_literature_title: 'إبلاغ مركز الآداب',
  crm_report_literature_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا الرد لمركز الآداب؟',
  crm_report_literature_abuse_reason: 'إبلاغ مركز الآداب عن إساءة',
  crm_report_literature_success: 'تم الإبلاغ عن الرد إلى مركز الآداب بنجاح',
  crm_report_law_title: 'إبلاغ مركز القانون',
  crm_report_law_message: 'هل أنت متأكد من أنك تريد الإبلاغ عن هذا الرد لمركز القانون؟',
  crm_report_law_violation_reason: 'إبلاغ مركز القانون عن إنتهاك القانون',
  crm_report_law_success: 'تم الإبلاغ عن الرد إلى مركز القانون بنجاح',
  crm_login_required_for_report: 'يجب تسجيل الدخول للإبلاغ',
  crm_report_submit_success: 'تم إرسال البلاغ بنجاح. شكراً لمساهمتك في الحفاظ على المجتمع.',
  crm_report_submit_error: 'حدث خطأ أثناء إرسال البلاغ. حاول لاحقاً.',
  crm_delete_reply_title: 'حذف الرد',
  crm_delete_reply_message: 'هل أنت متأكد من أنك تريد حذف هذا الرد؟ لا يمكن التراجع عن هذا الإجراء.',
  crm_delete_btn: 'حذف',
  crm_cancel_btn: 'إلغاء',
  crm_deleted_title: 'تم الحذف',
  crm_delete_success: 'تم حذف الرد بنجاح',
  crm_delete_error: 'حدث خطأ أثناء حذف الرد',
  crm_surah_label: 'سورة',
  crm_banned_title: 'محظور',
  crm_banned_reply_message: 'لديك حظر على التعليق ولا يمكنك كتابة رد.',
  crm_comment_deleted: 'التعليق محذوف',
  crm_reply_deleted: 'الرد محذوف',
  crm_modal_title: 'ردود التعليق',
  crm_block_reason_theft: 'رد مسروق',
  crm_unblock_reply_theft: 'إلغاء حظر الرد (سرقة)',
  crm_block_reply_theft: 'حظر الرد (رد مسروق)',
  crm_block_reason_literature: 'رد مخل للآداب',
  crm_unblock_reply_literature: 'إلغاء حظر الرد (آداب)',
  crm_block_reply_literature: 'حظر الرد (رد مخل للآداب)',
  crm_block_reason_law: 'رد خارج عن القانون',
  crm_unblock_reply_law: 'إلغاء حظر الرد (قانون)',
  crm_block_reply_law: 'حظر الرد (رد خارج عن القانون)',
  crm_report_health_depression: 'إبلاغ مركز الصحة عن حالة إكتئاب',
  crm_edit_reply: 'تعديل الرد',
  crm_comment_label: 'التعليق',
  crm_reply_on_label: 'رد على {target}',
  crm_report_dialog_heading: 'إبلاغ عن الرد',
  crm_report_dialog_subtitle: 'اكتب تفاصيل البلاغ ليتمكن المشرفون من المراجعة بشكل أفضل',
  crm_report_details_label: 'تفاصيل البلاغ',
  crm_report_details_placeholder: 'مثال: هذا الرد يحتوي على إساءة أو تهديد...',
  crm_send_report_btn: 'إرسال البلاغ',
  crm_yes_btn: 'نعم',

  // PostCommentsModal.jsx - extra keys (pass 2)
  pcm_coins_sent_to_post: 'أرسلت عملات إلى منشور {name}',
  pcm_coins_sent_with_comment: 'خصم لإرسال عملات مع تعليق على منشور',
  pcm_coins_received_from: 'حصلت على عملات من {name}',
  pcm_coins_received_with_comment: 'استلام عملات من تعليق على منشورك',
  pcm_block_reason_fallback: 'حظر/إلغاء حظر تعليق ({blockType})',
  pcm_comments_closed_banner: '🔒 التعليقات مغلقة على هذا المنشور',
  pcm_reactions_closed_banner: '💔 التفاعلات مغلقة على هذا المنشور',
  pcm_no_comments_yet: 'لاتوجد تعليقات على هذا المنشور',
  pcm_pinned_comment_badge: '📌 تعليق مثبت',
  pcm_edit_comment_menu: 'تعديل التعليق',
  pcm_delete_comment_menu: 'حذف التعليق',
  pcm_spoiler_warning: 'هذا التعليق يحتوي على حرق, إضغط لعرض التعليق',

  // CommentReplyModal.jsx - extra keys (pass 2)
  crm_block_reason_fallback: 'حظر/إلغاء حظر رد ({blockType})',
  crm_edit_reply_menu: 'تعديل الرد',
  crm_delete_reply_menu: 'حذف الرد',
  crm_report_reply_menu: 'إبلاغ الرد',
  crm_spoiler_warning: 'هذا الرد يحتوي على حرق اضغط لمشاهدة الرد',
  crm_comments_closed_banner: 'التعليقات مغلقة على هذا المنشور',

  // PostActionsComponent.jsx
  post_action_reaction_like: 'أفدتني',
  post_action_reaction_love: 'أبدعت',
  post_action_reaction_care: 'إستمر',
  post_action_reaction_haha: 'أضحكني',
  post_action_reaction_wow: 'أدهشني',
  post_action_reaction_sad: 'أحزنني',
  post_action_reaction_angry: 'أغضبني',
  post_action_default_post_title: 'شاهد هذا المنشور',
  post_action_share_text: 'شاهد هذا المنشور!',
  post_action_share: 'مشاركة',
  post_action_comments: 'التعليقات',
  post_action_comments_closed: 'التعليقات مغلقة',
  post_action_reactions_closed: 'التفاعلات مغلقة',
  post_action_comments_closed_title: 'التعليقات مغلقة',
  post_action_comments_closed_message: 'لقد قام الكاتب بإغلاق التعليقات على هذا المنشور.',
  post_action_ok: 'حسناً',
  post_action_view_comments: 'عرض التعليقات',


  // HashtagDropDown.jsx
  hashtag_dropdown_no_results_found: 'لا توجد نتائج',
  hashtag_dropdown_create_new: 'إنشاء جديد: #',


  // CommentInputBox.jsx
  comment_input_box_comment_placeholder: 'إضافة تعليق',
  comment_input_box_invalid_image_type: ' صيغة الملف غير مدعومة',
  comment_input_box_image_upload_failed: 'فشل تحميل الصورة',
  comment_input_box_mentions_no_results_found: 'لايوجد شخص بهذا الإسم',
  comment_input_box_character_no_results_found: 'لاتوجد شخصيات بهذا الإسم',
  comment_input_box_character_category_prophets: 'الأنبياء',
  comment_input_box_character_category_companions: 'الصحابة',
  comment_input_box_character_category_historical: 'شخصيات تاريخية',
  comment_input_box_quran_surah_no_results_found: 'لا توجد سورة بهذا الإسم',
  comment_input_box_quran_surah_header: 'سور القرآن الكريم',
  comment_input_box_quran_surah_name: 'سورة',
  comment_input_box_edit_mode_title: 'تعديل التعليق',
  comment_input_box_comments_disabled: 'التعليقات مغلقة',
  time_ago_just_now: 'منذ لحظات',
  time_ago_one_minute: 'منذ دقيقة',
  time_ago_minutes: 'منذ {count} دقائق',
  time_ago_one_hour: 'قبل ساعة',
  time_ago_two_hours: 'قبل ساعتين',
  time_ago_hours: 'منذ {count} ساعات',
  time_ago_hours_alt: 'منذ {count} ساعة',
  time_ago_one_day: 'قبل يوم',
  time_ago_two_days: 'قبل يومين',
  time_ago_days: 'منذ {count} أيام',
  time_ago_days_alt: 'منذ {count} يوم',
  time_ago_one_week: 'قبل أسبوع',
  time_ago_two_weeks: 'قبل أسبوعين',
  time_ago_weeks: 'منذ {count} أسابيع',
  time_ago_one_month: 'قبل شهر',
  time_ago_two_months: 'قبل شهرين',
  time_ago_months: 'منذ {count} أشهر',
  notifications_page_no_notifications: 'لا توجد إشعارات',
  notifications_page_title: 'الإشعارات',
  notifications_page_filter_all: 'الكل',
  notifications_page_filter_posts: 'منشورات',
  notifications_page_filter_comments: 'تعليقات',
  notifications_page_filter_coins: 'عملات',
  notifications_page_filter_replies: 'ردود',
  notifications_page_filter_team_request: 'طلبات الفريق',
  notifications_page_filter_team_approval: 'قبول الفريق',
  notifications_page_filter_team_promotion: 'ترقية الفريق',
  notifications_page_filter_team_kick: 'طرد من الفريق',
  notifications_page_filter_saraha: 'صارحني',
  notifications_page_filter_coins_sent: 'عملات واردة',
  notifications_page_filter_blocked: 'محظور',
  notifications_page_filter_unblocked: 'غير محظور',
  notifications_page_tab_follow: 'المتابعة',
  notifications_page_tab_reaction: 'التفاعل',
  notifications_page_tab_messages: 'الرسائل',
  notifications_page_tab_general: 'عام',
  notifications_page_mark_all_read: 'تم مشاهدة الكل',
  notifications_page_delete_all: 'حذف الكل',
  notifications_page_post_blocked: 'تم حظر منشورك من قبل الإدارة',
  notifications_page_profile_image_blocked: 'تم حظر صورة ملفك الشخصي من قبل الإدارة',
  notifications_page_cover_image_blocked: 'تم حظر غلاف ملفك الشخصي من قبل الإدارة',
  notifications_page_reply_blocked: 'تم حظر ردك لأنه {reason}',
  notifications_page_comment_blocked: 'تم حظر تعليقك لأنه {reason}',
  notifications_page_reply_unblocked: 'تم إلغاء حظر ردك',
  notifications_page_comment_unblocked: 'تم إلغاء حظر تعليقك',
  notifications_page_text_chat_message: 'رسالة جديدة من {name}: "{snippet}"',
  notifications_page_text_follow: 'قام {name} بمتابعتك',
  notifications_page_text_reaction_post: 'تفاعل {name} على منشورك',
  notifications_page_text_reaction_comment: 'تفاعل {name} على تعليقك',
  notifications_page_text_reaction_reply: 'تفاعل {name} على ردك',
  notifications_page_text_reaction_generic: 'تفاعل {name} مع منشورك',
  notifications_page_text_mention: 'ذكرك {name} في منشور',
  notifications_page_text_comment: 'علق {name} على منشورك',
  notifications_page_text_comment_with_message: 'علق {name} على منشورك: "{message}"',
  notifications_page_text_comment_with_coins: 'أرسل لك {name} {coins} من العملات في تعليق',
  notifications_page_text_coins_with_comment: 'أرسل لك {name} {coins} من العملات في تعليق',
  notifications_page_text_reply: 'رد {name} على تعليقك',
  notifications_page_text_reply_with_message: 'رد {name} على تعليقك: "{message}"',
  notifications_page_text_reply_with_coins: 'أرسل لك {name} {coins} من العملات في رد',
  notifications_page_text_private_message: 'رسالة خاصة من {name}: "{snippet}"',
  notifications_page_text_group_message: 'رسالة مجموعة {group} من {name}: "{snippet}"',
  notifications_page_text_team_request: 'طلب انضمام جديد لفريقك',
  notifications_page_text_team_approval: 'تمت الموافقة على طلبك للانضمام إلى فريق {team}',
  notifications_page_text_team_promotion: 'تمت ترقيتك في فريق {team}{role}',
  notifications_page_text_team_promotion_role: ' إلى {role}',
  notifications_page_text_team_kick: 'تم طردك من فريق {team}',
  notifications_page_text_saraha_named: 'لقد وصلتك رسالة صارحني من مجهول: "{message}"',
  notifications_page_text_saraha_from: 'لقد وصلتك رسالة صارحني من {name}: "{message}"',
  notifications_page_text_saraha_anonymous: 'لديك رسالة صارحني جديدة من مجهول',
  notifications_page_text_saraha_generic: 'لديك رسالة صارحني جديدة',
  notifications_page_text_coins_sent: 'أرسل لك {name} {coins} من العملات',
  notifications_page_text_default: 'إشعار جديد',
  notifications_page_unknown_user: 'مستخدم',
  notifications_page_load_error: 'تعذّر تحميل الإشعارات. تحقق من الاتصال وحاول مرة أخرى.',
  notifications_page_retry: 'إعادة المحاولة',
  notifications_page_delete_confirm: 'هل تريد حذف هذا الإشعار؟',
  notifications_page_toast_from: 'من {name}',
  notifications_page_toast_new: 'إشعار جديد',
  notifications_page_toast_snooze: 'إخفاء',
  notifications_page_toast_snooze_title: 'إخفاء لمدة 5 دقائق',
  friend_requests_title_requests: 'طلبات ذات صِلة',
  friend_requests_title_contacts: 'جهات الإتصال',
  friend_requests_search_placeholder: 'ابحث عن شخص ذات صِلة...',
  friend_requests_no_contacts: 'لم تقم بإضافة أي أشخاص ذات صِلة بعد.',
  friend_requests_no_results: 'لا توجد نتائج مطابقة.',
  friend_requests_sent_you_request: 'أرسل لك طلب شخص ذات صِلة بك',
  friend_requests_accept_btn: 'قبول',
  friend_requests_reject_btn: 'رفض',
  friend_requests_no_new_requests: 'لا توجد طلبات ذات صِلة جديدة',
  friend_requests_edit_name_dialog: 'تعديل الاسم',
  friend_requests_update_btn: 'تحديث',
  friend_requests_cancel_btn: 'إلغاء',
  friend_requests_profile_image_alt: 'الصورة',
  friend_requests_more_options_label: 'المزيد من الخيارات',
  friend_requests_contacts_count_label: 'جهات الاتصال',
  friend_requests_favorites_section: 'المفضلات',
  friend_requests_remove_favorite: 'إزالة من المفضلات',
  friend_requests_add_favorite: 'إضافة إلى المفضلات',
  friend_requests_remove_contact: 'إزالة جهة الاتصال',
  friend_requests_incoming_tab: 'الواردة',
  friend_requests_add_person_tab: 'إضافة شخص',
  friend_requests_add_person_search_placeholder: 'ابحث بالـ UID أو المعرف',
  friend_requests_add_person_hint: 'ابحث بالـ UID أو اسم المستخدم لإضافة شخص',
  friend_requests_add_person_searching: 'جارٍ البحث...',
  friend_requests_add_person_no_results: 'لم يتم العثور على مستخدمين',
  friend_requests_already_related_label: 'مرتبط بالفعل',
  friend_requests_request_sent_label: 'تم إرسال الطلب',
  friend_requests_send_request_btn: 'إرسال طلب',
  friend_requests_send_request_error: 'فشل في إرسال طلب الصداقة',
  messages_title: 'الرسائل',
  messages_group_fallback: 'مجموعة',
  messages_search_chats_placeholder: 'ابحث في المحادثات...',
  messages_search_groups_placeholder: 'ابحث في المجموعات...',
  messages_search_aria: 'بحث',
  messages_new_group_aria: 'مجموعة جديدة',
  messages_tab_friends: 'المعارف',
  messages_tab_groups: 'المجموعات',
  messages_start_chat_now: 'ابدأ المحادثة الآن...',
  messages_no_previous_chats: 'ليس لديك رسائل سابقة. انقر على الزر بالأسفل لبدء محادثة.',
  messages_no_results: 'لا يوجد نتائج مطابقة.',
  messages_public_groups: 'المجموعات العامة',
  messages_public_groups_subtitle: 'اكتشف واستكشف المجتمعات',
  messages_no_messages: 'لا يوجد رسائل...',
  messages_no_groups: 'لا توجد مجموعات لديك حالياً... يمكنك إنشاء مجموعة أو الانضمام لمجموعات من الاستكشاف.',
  messages_new_message: 'رسالة جديدة',
  messages_create_group: 'إنشاء مجموعة',
  messages_unmute_notifications: 'إلغاء كتم الإشعارات',
  messages_mute_notifications: 'كتم الإشعارات',
  messages_rename: 'تغيير الاسم',
  messages_cancel_report: 'إلغاء الإبلاغ',
  messages_report: 'إبلاغ',
  messages_leave_group: 'مغادرة المجموعة',
  messages_new_chat_search_placeholder: 'ابحث عن شخص...',
  messages_start_new_chat: 'بدء محادثة جديدة',
  messages_no_available_people: 'لا يوجد أشخاص متاحين لبدء محادثة جديدة.',
  messages_no_results_short: 'لا توجد نتائج.',
  messages_rename_contact_title: 'تغيير اسم جهة الاتصال',
  messages_rename_contact_subtitle: 'سيظهر هذا الاسم فقط لك',
  messages_rename_placeholder: 'اكتب الاسم الجديد...',
  messages_cancel: 'إلغاء',
  messages_save: 'حفظ',
  messages_loading: 'جاري التحميل...',
  messages_load_more: 'تحميل المزيد',
  messages_deleted_message: 'تم حذف هذه الرسالة',
  quran_title: 'القرآن الكريم',
  quran_my_list: 'قائمتي',
  quran_loading: 'جاري التحميل...',
  quran_search_placeholder: 'ابحث عن سورة...',
  quran_sync_success_title: 'تمت المزامنة',
  quran_sync_success_message: 'تمت مزامنة {count} تغيير مع السيرفر بنجاح',
  quran_offline_title: 'لا يوجد اتصال',
  quran_offline_message: 'لا يوجد لديك إنترنت في الوقت الحالي، سيتم حفظ البيانات داخلياً ومزامنتها مع السيرفر عند الاتصال لاحقاً.',
  quran_unavailable_offline_title: 'غير متاح أوفلاين',
  quran_unavailable_offline_message: 'هذه السورة لم تُفتح من قبل ولا يوجد لها نسخة محفوظة. يرجى الاتصال بالإنترنت لفتحها أول مرة.',
  quran_tab_reading: 'القراءة',
  quran_tab_details: 'التفاصيل',
  quran_no_cached_surah: 'لا يوجد اتصال بالإنترنت ولا توجد نسخة محفوظة لهذه السورة.',
  quran_open_once_hint: 'افتحها مرة واحدة أثناء الاتصال حتى تُحفظ للاستخدام دون إنترنت.',
  quran_reset_progress_title: 'إعادة تعيين التقدم',
  quran_skip_ayahs_title: 'تخطي آيات',
  quran_skip_ayahs_message: 'هل أنت متأكد أنك قرأت حتى الآية {target}؟ آخر آية قرأتها كانت الآية {last}',
  quran_reset_progress_message: 'هل أنت متأكد من إعادة تعيين تقدم قراءة سورة {surah}؟ سيتم حذف التقدم بالكامل.',
  quran_info_type: 'النوع',
  quran_info_ayahs: 'عدد الآيات',
  quran_info_surah_number: 'رقم السورة',
  quran_memorization_status: 'حالة الحفظ',
  quran_status_none: '-- لا يوجد --',
  quran_status_want_to_memorize: 'أرغب بحفظها',
  quran_status_memorizing: 'أحفظها حالياً',
  quran_status_memorized: 'تم حفظها',
  quran_status_later: 'أحفظها لاحقاً',
  quran_status_difficult: 'صعبة الحفظ',
  quran_revelation_meccan: 'مكية',
  quran_revelation_medinan: 'مدنية',
  quran_ayah_count: '{count} آية',
  my_quran_list_empty_status: 'لا توجد سور في هذه الحالة',
  deleted_posts_title: 'المنشورات المحذوفة',
  deleted_posts_checking_permissions: 'جاري التحقق من الصلاحيات...',
  deleted_posts_no_permission: 'لا توجد صلاحيات للوصول لهذه الصفحة',
  deleted_posts_search_placeholder: 'ابحث بـ Post ID أو User ID أو الاسم...',
  deleted_posts_search_prompt: 'ابحث لعرض المنشورات المحذوفة (يتم التحميل فقط بعد البحث لتوفير الاستهلاك)',
  deleted_posts_loading: 'جاري تحميل المنشورات المحذوفة...',
  deleted_posts_empty: 'لا توجد منشورات محذوفة',
  deleted_posts_no_results: 'لم يتم العثور على نتائج للبحث',
  deleted_posts_deleted_at: 'محذوف',
  deleted_posts_recover_title: 'استعادة المنشور',
  deleted_posts_recover_message: 'هل تريد استعادة هذا المنشور؟',
  deleted_posts_recover_confirm: 'استعادة',
  deleted_posts_permanent_delete_title: 'حذف نهائي',
  deleted_posts_permanent_delete_message: 'هل تريد حذف هذا المنشور بشكل نهائي؟ لا يمكن التراجع عن هذا الإجراء.',
  deleted_posts_permanent_delete_confirm: 'حذف نهائي',
  deleted_posts_yes: 'نعم',
  deleted_posts_cancel: 'إلغاء',
  create_post_list_title: 'إنشاء قائمة جديدة',
  create_post_list_image_label: 'صورة القائمة',
  create_post_list_uploading: 'جاري الرفع...',
  create_post_list_image_hint: 'اضغط لاختيار صورة الغلاف الخاصة بالقائمة',
  create_post_list_name_label: 'اسم القائمة',
  create_post_list_name_placeholder: 'أدخل اسم القائمة هنا...',
  create_post_list_create_button: 'إنشاء القائمة',
  create_post_list_creating: 'جاري الإنشاء...',
  create_post_list_valid_image_required: 'الرجاء اختيار صورة صالحة',
  create_post_list_upload_error: 'حدث خطأ أثناء رفع الصورة',
  create_post_list_name_and_image_required: 'الرجاء إدخال اسم القائمة واختيار صورة',
  create_post_list_success: 'تم إنشاء القائمة بنجاح!',
  create_post_list_create_error: 'حدث خطأ أثناء إنشاء القائمة',
  saved_posts_title: 'المنشورات المحفوظة',
  saved_posts_loading: 'جاري التحميل...',
  saved_posts_empty: 'لا توجد منشورات محفوظة',
  team_posts_loading: 'تحميل...',
  team_posts_team_fallback: 'الفريق',
  team_posts_empty: 'لا توجد منشورات لهذا الفريق',
  team_posts_load_error: 'حدث خطأ في تحميل المنشورات',
  team_posts_retry: 'إعادة المحاولة',
  team_posts_load_more: 'عرض المزيد',
  team_posts_try_another: 'جرب البحث عن فريق آخر',
  team_posts_back_home: 'العودة إلى الرئيسية',
  team_posts_count: '{count} منشور',
  team_posts_level: 'المستوى: {level}',
  hashtag_posts_loading: 'جاري تحميل المنشورات...',
  hashtag_posts_empty: 'لا توجد منشورات بهذا الهاشتاق حتى الآن',
  hashtag_posts_load_error: 'تعذر تحميل منشورات الهاشتاق',
  profile_menu_no_daily_quiz_today: 'لا يوجد سؤال متاح لليوم',
  profile_menu_frame_alt: 'إطار الملف الشخصي',
  profile_menu_verified_alt: 'موثق',
  profile_menu_coin_alt: 'عملة',
  profile_menu_point_alt: 'نقطة',
  profile_menu_ok: 'موافق',
  manage_hashtags_title: 'إدارة الهاشتاغات',
  manage_hashtags_loading: 'جاري التحميل...',
  manage_hashtags_empty: 'لم تقم بإنشاء أي هاشتاغات بعد',
  manage_hashtags_usage_count: 'استخدم {count} مرة',
  manage_hashtags_private: 'خاص',
  manage_hashtags_delete_title: 'حذف الهاشتاغ',
  manage_hashtags_delete_message: 'هل أنت متأكد من حذف الهاشتاغ #{hashtag}؟',
  staff_loading: 'جاري التحميل...',
  staff_title: 'طاقم المشرفين',
  staff_empty: 'لا توجد بيانات متاحة',
  staff_group_1: 'الإدارة العليا',
  staff_group_technical_content: 'قسم فني محتوى',
  staff_group_2: 'قسم المحتوى',
  staff_group_3: 'قسم الفعاليات',
  staff_group_4: 'قسم البيانات',
  staff_group_5: 'أخرى',
  staff_role_1: 'المشرف العام',
  staff_role_1_5: 'نائب المشرف العام',
  staff_role_1_6: 'مسؤول قسم فني محتوى',
  staff_role_1_7: 'فني محتوى',
  staff_role_2: 'مسؤول قسم المحتوى',
  staff_role_3: 'مشرف المحتوى',
  staff_role_4: 'مسؤول قسم الفعاليات',
  staff_role_5: 'مشرف الفعاليات',
  staff_role_6: 'مسؤول قسم البيانات',
  staff_role_7: 'مشرف البيانات',
  staff_role_10: 'غير مخصص',
  staff_role_user: 'مستخدم',
  staff_role_unassigned: 'غير مخصص',
  staff_change_role_title: 'تغيير رتبة {name}',
  staff_save: 'حفظ',
  staff_cancel: 'إلغاء',
  tasbeeh_title: 'مسابقة الأذكار',
  tasbeeh_tab_recent: 'مؤخراً',
  tasbeeh_tab_favorites: 'المفضلة',
  tasbeeh_tab_main: 'الرئيسية',
  tasbeeh_empty_favorites: 'لم تقم بإضافة شيء إلى المفضلة بعد',
  tasbeeh_empty_recent: 'لم تقم باستخدام أي أذكار مؤخراً',
  tasbeeh_show_adhkar: 'عرض الأذكار',
  tasbeeh_counter_sync_title: 'تمت المزامنة',
  tasbeeh_counter_sync_message: 'تمت مزامنة تقدمك مع السيرفر بنجاح',
  tasbeeh_counter_offline_title: 'لا يوجد اتصال',
  tasbeeh_counter_offline_message: 'لا يوجد لديك إنترنت في الوقت الحالي، سيتم حفظ البيانات داخلياً ومزامنتها عند فتح الصفحة لاحقاً.',
  tasbeeh_counter_purple_potion_title: 'تم استخدام Purple Potion',
  tasbeeh_counter_purple_potion_message: 'تم استخدام Purple Lazy Potion وحفظ تقدمك في التسابيح والأذكار معاً.',
  tasbeeh_counter_streak_broken_title: 'انقطع التقدم',
  tasbeeh_counter_streak_broken_message: 'انقطعت سلسلة التقدم الخاصة بك وكانت {count} يوم. ابدأ من جديد.',
  tasbeeh_counter_blue_potion_title: 'تم استخدام Blue Potion',
  tasbeeh_counter_blue_potion_message: 'تم استخدام Blue Lazy Potion للحفاظ على تقدم التسابيح.',
  tasbeeh_counter_badge_name: 'درع المستوى {level}',
  tasbeeh_counter_badge_updated_title: 'تم تحديث الشارة',
  tasbeeh_counter_badge_updated_message: 'تهانينا! تمت ترقية شارتك إلى درع المستوى {level} بعد {count} يوم متواصل.',
  tasbeeh_counter_badge_new_title: 'شارة جديدة',
  tasbeeh_counter_badge_new_message: 'تهانينا! حصلت على درع المستوى {level} بعد {count} يوم متواصل.',
  tasbeeh_counter_temp_block_title: 'محظور مؤقتاً',
  tasbeeh_counter_temp_block_message: 'تم تفعيل حظر مؤقت لمدة {count} دقيقة بسبب محاولات الغش. حاول لاحقاً.',
  tasbeeh_counter_no_cheating_title: 'ممنوع الغش',
  tasbeeh_counter_no_cheating_message: 'الغش غير مسموح. تم تفعيل حظر مؤقت لمدة {count} دقيقة.',
  tasbeeh_counter_next_level: 'المستوى التالي',
  tasbeeh_counter_streak_days: '{count} يوم متواصل',
  tasbeeh_counter_tap_anywhere: 'اضغط في أي مكان للتسبيح',
  tasbeeh_counter_achievement_title: '🎖️ نقطة إنجاز جديدة!',
  tasbeeh_counter_achievement_message: 'وصلت إلى {count} ذكر! حصلت على نقطة إنجاز "ذاكر" 📿',
  tasbeeh_counter_goal_modal_title: 'الهدف اليومي',
  tasbeeh_counter_goal_modal_description: 'اختر عدد الأذكار الذي تحتاج للوصول إليه للحصول على نقطة إنجاز واحدة.',
  tasbeeh_counter_goal_modal_label: 'الهدف',
  tasbeeh_counter_goal_modal_save: 'حفظ',
  tasbeeh_counter_goal_modal_cancel: 'إلغاء',
  tasbeeh_counter_goal_modal_invalid: 'الرجاء إدخال رقم بين {min} و {max}',
  tasbeeh_sequence_mode: 'وضع التسلسل',
  tasbeeh_sequence_hint: 'اختر الأذكار بالترتيب الذي تريد التسبيح به',
  tasbeeh_sequence_start: 'ابدأ التسلسل ({count})',
  tasbeeh_sequence_cancel: 'إلغاء',
  tasbeeh_sequence_min_error: 'اختر ذكرين على الأقل لبدء التسلسل',
  tasbeeh_sequence_progress: 'الذكر {current} من {total}',
  tasbeeh_sequence_mix_total: 'إجمالي المزيج: {count}',
  tasbeeh_sequence_next_label: 'الذكر التالي',
  tasbeeh_sequence_complete_title: 'أكملت السلسلة! 🎉',
  tasbeeh_sequence_complete_message: 'أحسنت! أكملت جميع الأذكار في سلسلتك.',
  store_title: 'متجر امبوستر',
  store_subtitle: 'اكتشف العناصر والإضافات المفيدة',
  store_points_unit: 'نقطة',
  store_coins_unit: 'عملة',
  store_current_pack: 'الحزمة الحالية',
  store_active_pack: 'الحزمة النشطة',
  store_remaining_days: 'متبقي {count} يوم',
  store_expired: 'منتهية الصلاحية',
  store_coming_soon: 'قريباً',
  store_category_conversion: 'تحويل العملات والنقاط',
  store_category_potions: 'متجر الأدوات',
  store_category_reactions: 'أيقونات التفاعل',
  store_category_stickers: 'متجر الملصقات',
  store_category_bubbles: 'متجر الفقاعات',
  store_category_frames: 'إطارات البروفايل',
  store_category_themes: 'لاحقاً',
  store_category_special: 'عروض خاصة',
  store_convert_coins_to_points: 'تحويل العملات إلى نقاط',
  store_convert_points_to_coins: 'تحويل النقاط إلى عملات',
  store_convert_coins_subtitle: 'حوّل عملاتك إلى نقاط لشراء العناصر',
  store_convert_points_subtitle: 'حوّل نقاطك إلى عملات',
  store_current_tax: 'الضريبة الحالية',
  store_example: 'مثال',
  store_conversion_amount_label: 'المبلغ المراد تحويله ({unit})',
  store_enter_amount: 'أدخل المبلغ',
  store_coins_to_convert: 'العملات المراد تحويلها',
  store_points_to_convert: 'النقاط المراد تحويلها',
  store_tax: 'الضريبة',
  store_points_received: 'النقاط المستلمة',
  store_coins_received: 'العملات المستلمة',
  store_not_enough_points: 'المعذرة، لا تملك نقاطاً كافية',
  store_not_enough_points_purchase: 'نقاطك غير كافية لإتمام الشراء',
  store_purchase_success_named: 'تم شراء {name} بنجاح!',
  store_purchase_error: 'حدث خطأ أثناء الشراء',
  store_blue_potion_name: 'جرعة الكسل الزرقاء',
  store_blue_potion_desc: 'تحمي سلسلة التسبيح من الانقطاع',
  store_orange_potion_name: 'جرعة الكسل البرتقالية',
  store_orange_potion_desc: 'تحمي سلسلة الأذكار من الانقطاع',
  store_purple_potion_name: 'جرعة الكسل النادرة',
  store_purple_potion_desc: 'تحمي سلسلة التسبيح والأذكار معاً',
  store_potions_title: 'متجر الأدوات',
  store_potions_subtitle: 'احمِ تقدمك باستخدام جرعات الكسل',
  store_owned_count: 'تملك: {count}',
  store_buying: 'جاري الشراء...',
  store_buy: 'شراء',
  store_confirm_purchase_title: 'تأكيد الشراء',
  store_confirm_purchase_message: 'هل تود شراء {name}؟',
  store_yes: 'نعم',
  store_no: 'لا',
  store_stickers_title: 'متجر الملصقات',
  store_stickers_subtitle: 'اشترِ حزم ملصقات لتمييز محادثاتك',
  store_sticker: 'ملصق',
  store_stickers_preview: 'معاينة الملصقات',
  store_sticker_purchase_success: 'تم شراء حزمة الملصقات بنجاح!',
  store_owned: 'مملوكة',
  store_already_owned: 'مملوكة بالفعل',
  store_no_stickers: 'لا توجد ملصقات متاحة للشراء حالياً.',
  store_preview: 'معاينة',
  store_reactions_title: 'متجر الأيقونات التفاعلية',
  store_reactions_subtitle: 'اختر حزمتك المفضلة من الأيقونات',
  store_reaction_pack_name: 'حزمة الأيقونات {number}',
  store_reaction_pack_default_desc: 'الحزمة الافتراضية - مجانية',
  store_reaction_pack_desc: 'مجموعة من 7 أيقونات تفاعلية فريدة - صالحة لمدة 30 يوم',
  store_reactions_preview: 'معاينة الأيقونات',
  store_active: 'نشطة',
  store_free: 'مجاني',
  store_active_now: 'نشطة الآن',
  store_activate: 'تفعيل',
  store_activate_free: 'تفعيل مجاناً',
  store_loading: 'جاري التحميل...',
  store_login_required: 'يجب تسجيل الدخول للوصول إلى المتجر',
  moderation_logs_title: 'سجل إجراءات المشرفين',
  moderation_logs_loading: 'جاري التحميل...',
  moderation_logs_tab_logs: 'السجل',
  moderation_logs_tab_stats: 'الإحصائيات',
  moderation_logs_total_actions: 'إجمالي الإجراءات',
  moderation_logs_need_verification: 'إجراءات تحتاج تحقق',
  moderation_logs_verified_actions: 'إجراءات تم التحقق منها',
  moderation_logs_by_action_type: 'حسب نوع الإجراء',
  moderation_logs_by_content_type: 'حسب نوع المحتوى',
  moderation_logs_by_block_type: 'حسب نوع الحظر',
  moderation_logs_action_block: 'حظر',
  moderation_logs_action_block_theft: 'حظر سرقة محتوى',
  moderation_logs_action_block_abuse: 'حظر إساءة',
  moderation_logs_action_block_legal: 'حظر مخالفة قانونية',
  moderation_logs_action_unblock: 'إلغاء حظر',
  moderation_logs_action_unblock_theft: 'إلغاء حظر سرقة محتوى',
  moderation_logs_action_unblock_abuse: 'إلغاء حظر إساءة',
  moderation_logs_action_unblock_legal: 'إلغاء حظر مخالفة قانونية',
  moderation_logs_action_delete: 'حذف منشور',
  moderation_logs_action_delete_short: 'حذف',
  moderation_logs_action_report: 'إبلاغ',
  moderation_logs_content_post: 'منشور',
  moderation_logs_content_comment: 'تعليق',
  moderation_logs_content_reply: 'رد',
  moderation_logs_content_profile_image: 'صورة بروفايل',
  moderation_logs_content_cover_image: 'صورة غلاف',
  moderation_logs_block_theft: 'سرقة محتوى',
  moderation_logs_block_abuse: 'إساءة',
  moderation_logs_block_legal: 'مخالفة قانونية',
  moderation_logs_search_placeholder: 'ابحث عن مشرف، مستخدم، أو ID...',
  moderation_logs_filter: 'فلترة',
  moderation_logs_verification_status: 'حالة التحقق',
  moderation_logs_unverified: 'لم يتم التحقق',
  moderation_logs_verified: 'تم التحقق',
  moderation_logs_all: 'الكل',
  moderation_logs_action_type: 'نوع الإجراء',
  moderation_logs_moderator: 'المشرف',
  moderation_logs_empty: 'لا توجد سجلات',
  moderation_logs_on: 'على',
  moderation_logs_reason: 'السبب',
  moderation_logs_type: 'النوع',
  moderation_logs_review_content: 'مراجعة المحتوى',
  moderation_logs_review: 'مراجعة',
  moderation_logs_mark_verified: 'تم التحقق',
  moderation_logs_confirm_title: 'تأكيد التحقق',
  moderation_logs_confirm_message: 'هل أنت متأكد من أن هذا السجل تمت مراجعته والتحقق منه؟',
  moderation_logs_confirm_yes: 'نعم، تم التحقق',
  moderation_logs_cancel: 'إلغاء',


  adhkar_benefit_title: 'الفائدة',
  adhkar_benefit_aria: 'عرض الفائدة',
  adhkar_once: 'مرة',
  adhkar_times: 'مرات',
  adhkar_tap_hint: 'اضغط للتسبيح',
  adhkar_completed_items: 'الأذكار المكتملة ({count})',
  adhkar_loading: 'جارٍ تحميل الأذكار...',
  adhkar_back: 'الرجوع',
  adhkar_title: 'أذكار الصباح والمساء',
  adhkar_subtitle: 'اضغط على كل ذكر للتسبيح. اضغط على ? لمعرفة الفائدة.',
  adhkar_morning_tab: 'أذكار الصباح',
  adhkar_evening_tab: 'أذكار المساء',
  adhkar_progress: 'التقدم',
  adhkar_streak_days: '{count} يوم',
  adhkar_done_title: 'أحسنت! أتممت جميع الأذكار',
  adhkar_done_subtitle: 'تقبل الله منك وبارك في يومك',
  adhkar_done_badge_subtitle: 'تهانينا، لقد حصلت على شارة صالحة لنهاية اليوم',
  adhkar_benefit_dialog_title: 'فائدة الذكر',
  adhkar_reorder_btn: 'ترتيب الأذكار',
  adhkar_reorder_done_btn: 'تم',
  adhkar_reorder_hint: 'اسحب ☰ لتغيير الترتيب، أو استخدم الأسهم',
  adhkar_reset_order_btn: 'استعادة الترتيب الافتراضي',
  adhkar_reset_order_confirm_title: 'استعادة الترتيب الافتراضي؟',
  adhkar_reset_order_confirm_message: 'سيعود ترتيب الأذكار إلى وضعه الأصلي. الأذكار الخاصة والمخفية لن تتأثر.',
  adhkar_drag_handle: 'اسحب لإعادة الترتيب',
  adhkar_move_up: 'تحريك للأعلى',
  adhkar_move_down: 'تحريك للأسفل',
  adhkar_custom_badge: 'خاص',
  adhkar_delete_custom: 'حذف الذكر الخاص',
  adhkar_add_custom_btn: 'إضافة ذكر خاص',
  adhkar_add_custom_title: 'إضافة ذكر خاص بك',
  adhkar_add_custom_name_label: 'اسم الذكر',
  adhkar_add_custom_text_label: 'نص الذكر',
  adhkar_add_custom_repeat_label: 'عدد التكرار',
  adhkar_add_custom_benefit_label: 'الفائدة (اختياري)',
  adhkar_add_custom_cancel: 'إلغاء',
  adhkar_add_custom_save: 'حفظ',
  adhkar_add_custom_saving: 'جارٍ الحفظ...',
  adhkar_add_custom_error: 'يرجى كتابة نص الذكر أولاً',
  adhkar_hide_base: 'إخفاء هذا الذكر',
  adhkar_restore_base: 'إعادة تفعيل',
  adhkar_hidden_items: 'الأذكار المخفية ({count})',
  adhkar_min_count_title: 'الحد الأدنى للأذكار',
  adhkar_min_count_message: 'يجب أن يبقى {count} ذكراً على الأقل ضمن هذا القسم. أضف ذكراً آخر أولاً إن أردت حذف أو إخفاء المزيد.',
  suggestions_box_status_all: 'الكل',
  suggestions_box_status_pending: 'قيد المراجعة',
  suggestions_box_status_in_development: 'قيد التطوير',
  suggestions_box_status_completed: 'تم الإنجاز',
  suggestions_box_status_rejected: 'مرفوض',
  suggestions_box_moderator: 'مشرف',
  suggestions_box_user: 'مستخدم',
  suggestions_box_reply_placeholder: 'اكتب ردك على هذا الطلب...',
  suggestions_box_sending: 'جاري الإرسال',
  suggestions_box_send_reply: 'إرسال الرد',
  suggestions_box_type_suggestion: 'اقتراح',
  suggestions_box_type_problem: 'مشكلة',
  suggestions_box_request_content: 'محتوى الطلب',
  suggestions_box_change_status: 'تغيير الحالة',
  suggestions_box_delete_request: 'حذف الطلب',
  suggestions_box_moderator_replies: 'ردود الإشراف ({count})',
  suggestions_box_recently: 'منذ قليل',
  suggestions_box_confirm: 'تأكيد',
  suggestions_box_cancel: 'إلغاء',
  suggestions_box_confirm_status_title: 'تأكيد تغيير الحالة',
  suggestions_box_confirm_status_message: 'تغيير حالة الطلب إلى "{status}"؟',
  suggestions_box_done: 'تم',
  suggestions_box_error: 'خطأ',
  suggestions_box_status_success: 'تم تحديث الحالة بنجاح',
  suggestions_box_status_error: 'تعذر تحديث الحالة',
  suggestions_box_delete_title: 'حذف الطلب',
  suggestions_box_delete_message: 'هل تريد حذف {type} نهائيا؟ سيتم حذف الردود المرتبطة به أيضا.',
  suggestions_box_delete: 'حذف',
  suggestions_box_deleted: 'تم الحذف',
  suggestions_box_delete_success: 'تم حذف الطلب بنجاح',
  suggestions_box_delete_error: 'تعذر حذف الطلب',
  suggestions_box_title: 'صندوق الاقتراحات والمشاكل',
  my_reports_suggestions_tab: 'المشاكل/الاقتراحات',
  my_reports_no_suggestions: 'لا توجد مشاكل/اقتراحات',
  suggestions_box_loading: 'جاري التحميل...',
  suggestions_box_total: 'الإجمالي',
  suggestions_box_waiting_review: 'بانتظار المراجعة',
  suggestions_box_empty_title: 'لا توجد طلبات',
  suggestions_box_empty_message: 'لا توجد طلبات مطابقة للفلتر المحدد.',
  pack_create_title: 'إنشاء مجموعة أذكار',
  pack_edit_title: 'تعديل مجموعة الأذكار',
  pack_status_draft: 'مسودة',
  pack_status_published: 'منشورة',
  pack_saving: 'جارٍ الحفظ…',
  pack_title_label: 'عنوان المجموعة',
  pack_title_placeholder: 'مثال: أذكار الصباح - حصن المسلم',
  pack_description_label: 'الوصف',
  pack_description_placeholder: 'ما الذي يميز هذه المجموعة (الترتيب، المصدر، أدعية إضافية)؟',
  pack_type_label: 'النوع',
  pack_type_both: 'صباح ومساء',
  pack_language_label: 'اللغة',
  pack_language_ar: 'العربية',
  pack_language_en: 'الإنجليزية',
  pack_language_both: 'عربي وإنجليزي',
  pack_scholar_label: 'الشيخ / العالم (اختياري)',
  pack_scholar_placeholder: 'مثال: ابن باز',
  pack_source_label: 'المصدر (اختياري)',
  pack_source_placeholder: 'مثال: حصن المسلم، صحيح البخاري',
  pack_items_title: 'أذكار هذه المجموعة ({count})',
  pack_add_item_title: 'إضافة ذكر',
  pack_edit_item_title: 'تعديل الذكر',
  pack_duplicate_item: 'نسخ الذكر',
  pack_add_below_item: 'إضافة ذكر أسفل هذا',
  pack_untitled_item: 'ذكر بلا عنوان',
  pack_item_time_label: 'ينطبق هذا الذكر على',
  pack_item_time_both: 'كلاهما',
  pack_item_time_morning: 'الصباح فقط',
  pack_item_time_evening: 'المساء فقط',
  pack_no_items_yet: 'لم تُضف أي أذكار بعد. اضغط "إضافة ذكر" للبدء.',
  pack_filter_all: 'الكل',
  pack_filter_no_items: 'لا توجد أذكار مطابقة لهذا الفلتر.',
  pack_min_items_hint: 'تحتاج ما لا يقل عن {count} ذكر لتتمكن من النشر.',
  pack_publish: 'نشر المجموعة',
  pack_republish: 'نشر التحديث',
  pack_publishing: 'جارٍ النشر…',
  pack_published_title: 'تم نشر المجموعة',
  pack_published_message: 'مجموعتك الآن مرئية للمراجعين، وستظهر للجميع بعد التوثيق.',
  pack_publish_error_title: 'لا يمكن النشر الآن',
  pack_publish_generic_error: 'حدث خطأ أثناء النشر. حاول مرة أخرى.',
  pack_missing_title_error: 'الرجاء إضافة عنوان للمجموعة قبل النشر.',
  pack_min_items_error: 'لديك {current} ذكر — تحتاج {count} على الأقل للنشر.',
  pack_first_publish_changelog: 'الإصدار الأول',
  pack_browse_btn: 'متجر الأذكار',
  pack_browse_title: 'استعرض مجموعات الأذكار',
  pack_create_new: 'إنشاء',
  pack_search_placeholder: 'ابحث بالعنوان…',
  pack_sort_popularity: 'الأكثر تنزيلاً',
  pack_sort_rating: 'الأعلى تقييماً',
  pack_sort_recent: 'الأحدث تحديثاً',
  pack_sort_installs: 'الأكثر استخداماً حالياً',
  pack_verified_only: 'الموثّقة فقط',
  pack_verified_label: 'مجموعة موثّقة',
  pack_no_results: 'لا توجد مجموعات بعد. كن أول من ينشر!',
  pack_no_ratings_yet: 'لا توجد تقييمات بعد',
  pack_reviews_modal_title: 'تقييمات المستخدمين',
  pack_reviews_empty: 'لا توجد تقييمات لعرضها بعد',
  pack_reviews_no_comment: 'بدون تعليق',
  pack_anonymous_reviewer: 'مستخدم',
  pack_install: 'تثبيت',
  pack_uninstall: 'إلغاء التثبيت',
  pack_use_this: 'استخدم هذه المجموعة',
  pack_currently_active: 'مُفعّلة حالياً',
  pack_bookmark: 'حفظ',
  pack_resume_drafts_title: 'لديك مسودات سابقة',
  pack_resume_drafts_subtitle: 'أكمل مسودة موجودة، أو ابدأ مجموعة جديدة من الصفر.',
  pack_continue_draft: 'متابعة',
  pack_start_new_pack: 'إنشاء مجموعة جديدة',
  pack_untitled_draft: 'مسودة بلا عنوان',
  pack_draft_item_count: '{count} ذكر',
  pack_edit_my_pack: 'تعديل المجموعة',
  pack_official_title: 'الأذكار الأصلية',
  pack_official_description: 'القائمة الافتراضية المدمجة في التطبيق',
  pack_installing: 'جارٍ التثبيت…',
  pack_rate_button: 'قيّم المجموعة',
  pack_rate_modal_title: 'قيّم هذه المجموعة',
  pack_rate_stars_label: 'تقييمك',
  pack_rate_text_label: 'تعليق (اختياري)',
  pack_rate_text_placeholder: 'شاركنا رأيك في هذه المجموعة…',
  pack_rate_select_stars_error: 'الرجاء اختيار عدد النجوم أولاً.',
  pack_rate_generic_error: 'حدث خطأ أثناء إرسال التقييم. حاول مرة أخرى.',
  pack_rate_submitting: 'جارٍ الإرسال…',
  pack_rate_submit: 'إرسال التقييم',
  pack_bookmarked_only: 'المحفوظة فقط',
  pack_bookmarked_empty: 'لم تحفظ أي مجموعة بعد.',
  pack_admin_verify: 'توثيق المجموعة',
  pack_admin_unverify: 'إلغاء التوثيق',
  pack_admin_unverify_confirm_title: 'إلغاء توثيق هذه المجموعة؟',
  pack_admin_unverify_confirm_message: 'ستفقد المجموعة شارة التوثيق وتظهر للمستخدمين كمجموعة غير موثّقة. يمكنك توثيقها مرة أخرى في أي وقت.',
  pack_admin_ban_author: 'حظر صاحب المجموعة',
  pack_admin_delete_pack: 'حذف المجموعة',
  pack_admin_ban_confirm_title: 'حظر صاحب هذه المجموعة؟',
  pack_admin_ban_confirm_message: 'لن يتمكن هذا المستخدم من إنشاء مجموعات أذكار جديدة بعد الآن. لا يؤثر هذا على المجموعات التي نشرها سابقاً.',
  pack_admin_delete_confirm_title: 'حذف هذه المجموعة؟',
  pack_admin_delete_confirm_message: 'ستُزال المجموعة من المتجر فوراً ولن تظهر للمستخدمين بعد الآن. هذا الإجراء مخصص للمحتوى المسيء أو المخالف.',
  pack_publish_editor_forbidden: 'فقط مؤلف المجموعة يمكنه نشر التحديثات. يمكنك تعديل المحتوى وحفظه كمسودة، وسيتولى المؤلف نشره.',
  pack_banned_title: 'لا يمكن إنشاء مجموعة',
  pack_banned_from_creating: 'تم حظرك من إنشاء مجموعات أذكار جديدة بسبب إساءة استخدام سابقة.',
  pack_delete_item_confirm_title: 'حذف هذا الذكر؟',
  pack_delete_item_confirm_message: 'لا يمكن التراجع عن هذا الإجراء بعد الحذف.',
  pack_confirm_delete: 'حذف',
  pack_verification_verified_badge: 'موثّقة',
  pack_verification_pending_badge: 'قيد المراجعة',
  pack_editor_role_badge: 'محرر (بدون صلاحية نشر)',
  pack_more_options: 'المزيد من الخيارات',
  profile_menu_wallet_currencies: 'عملات المحافظ',
  comments_external_link_forbidden: 'لا تملك صلاحية نشر روابط خارجية في التعليقات أو الردود.',
};
